/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(235);
	
	__webpack_require__(236);
	
	__webpack_require__(237);
	
	function DataSource() {
	    $.extend(this, new storeLocator.StaticDataFeed());
	    this.setStores(this.parse_(ROLI.storesData));
	}
	
	DataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(new storeLocator.Feature('grand', 'Seaboard GRAND'), new storeLocator.Feature('rise', 'Seaboard RISE'), new storeLocator.Feature('blocks', 'BLOCKS'), new storeLocator.Feature('songmakerkit', 'Songmaker Kit'));
	
	DataSource.prototype.getFeatures = function () {
	    return this.FEATURES_;
	};
	DataSource.prototype.parse_ = function (json) {
	    var stores = [];
	
	    for (var i = 0; i < json.length; i++) {
	        var row = json[i];
	
	        if (!row['online_only']) {
	
	            var features = new storeLocator.FeatureSet();
	            var products = row.products_sold || [];
	            for (var j = 0; j < products.length; j++) {
	                features.add(this.FEATURES_.getById(products[j]));
	            }
	
	            var position = new google.maps.LatLng(row.lat, row.lng);
	
	            var store = new storeLocator.Store(i, position, features, row);
	            stores.push(store);
	        }
	    }
	    return stores;
	};
	
	// Check connection to google works
	if (google && google.maps) {
	
	    // var ICON = new google.maps.MarkerImage(
	    //     '../public/assets/img/store-finder/roli-icon.png?x=y',
	    //     null,
	    //     null,
	    //     new google.maps.Point(0, 0)
	    //   );
	    google.maps.event.addDomListener(window, 'load', function () {
	        $('body').addClass('loading');
	        ROLI.storesData ? initMap() : document.addEventListener('loadStoresComplete', initMap, false);
	    });
	} else {
	    $('$js-map-load-error').show();
	}
	
	function initMap() {
	    $('body').removeClass('loading');
	
	    var lat, lng;
	    var reg = /\?lat=(-*\d+.*\d*)&lng=(-*\d+.*\d*)/i;
	    var latlng = window.location.href.match(reg);
	    var LocationInQuery = latlng;
	
	    if (LocationInQuery) {
	        lat = latlng[1];
	        lng = latlng[2];
	    } else {
	        //use defualt map center
	        lat = 43.767492;
	        lng = -36.203631;
	    }
	
	    var map = new google.maps.Map(document.getElementById('map-canvas'), {
	        center: new google.maps.LatLng(lat, lng),
	        zoom: LocationInQuery ? 10 : 3,
	        mapTypeId: google.maps.MapTypeId.ROADMAP,
	        mapTypeControl: false
	    });
	
	    var panelDiv = document.getElementById('map-panel');
	
	    var data = new DataSource();
	
	    var view = new storeLocator.View(map, data, {
	        geolocation: LocationInQuery ? false : true,
	        features: data.getFeatures()
	    });
	
	    view.createMarker = function (store) {
	        var markerOptions = {
	            position: store.getLocation(),
	            // icon: ICON,
	            title: store.getDetails().name
	        };
	        return new google.maps.Marker(markerOptions);
	    };
	
	    var infoBubble = new InfoBubble({
	        backgroundClassName: 'storefinder-panel store-infowindow ',
	        backgroundColor: $('.js-infowindow-bg-setter').css('backgroundColor'),
	        shadowStyle: 0,
	        padding: 0,
	        borderRadius: 0,
	        borderWidth: 0,
	        disableAutoPan: true,
	        hideCloseButton: true,
	        arrowPosition: 30,
	        arrowSize: 10,
	        arrowStyle: 0
	    });
	
	    view.getInfoWindow = function (store) {
	        if (store) {
	            var details = store.getDetails();
	            var hours = details.hours ? details.hours.join('<br>') : '';
	            var html = ['<div style="padding: 20px 20px 5px 20px;">', '<h4 class="store-infowindow__title">', '<a target="_blank" href="', details.website, '">', details.name, '</a>', '</h4>', '<p>', details.phone, '</p>', '<p>', details.address, '</p>', '<p>', hours, '</p>', store.generateFeaturesHTML_(), '</div>'].join('');
	            infoBubble.setContent($(html)[0]);
	        }
	        return infoBubble;
	    };
	
	    new storeLocator.Panel(panelDiv, {
	        view: view
	    });
	}

/***/ },

/***/ 235:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 236:
/***/ function(module, exports) {

	//NOTE: This library has been modified for our purposes, mostly for stylistic reasons rather than anything business critical, but that is why it is in the util folder rather than the vendor folder
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @name Store Locator for Google Maps API V3
	 * @version 0.1
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * This library makes it easy to create a fully-featured Store Locator for
	 * your business's website.
	 */
	
	/**
	 * @license
	 *
	 * Copyright 2012 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Namespace for Store Locator.
	 * @constructor
	 */
	'use strict';
	
	var storeLocator = function storeLocator() {};
	window['storeLocator'] = storeLocator;
	
	/**
	 * Convert from degrees to radians.
	 * @private
	 * @param {number} degrees the number in degrees.
	 * @return {number} the number in radians.
	 */
	storeLocator.toRad_ = function (degrees) {
	  return degrees * Math.PI / 180;
	};
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * Feature model class for Store Locator library.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Representation of a feature of a store. (e.g. 24 hours, BYO, etc).
	 * @example <pre>
	 * var feature = new storeLocator.Feature('24hour', 'Open 24 Hours');
	 * </pre>
	 * @param {string} id unique identifier for this feature.
	 * @param {string} name display name of this feature.
	 * @constructor
	 * @implements storeLocator_Feature
	 */
	storeLocator.Feature = function (id, name) {
	  this.id_ = id;
	  this.name_ = name;
	};
	storeLocator['Feature'] = storeLocator.Feature;
	
	/**
	 * Gets this Feature's ID.
	 * @return {string} this feature's ID.
	 */
	storeLocator.Feature.prototype.getId = function () {
	  return this.id_;
	};
	
	/**
	 * Gets this Feature's display name.
	 * @return {string} this feature's display name.
	 */
	storeLocator.Feature.prototype.getDisplayName = function () {
	  return this.name_;
	};
	
	storeLocator.Feature.prototype.toString = function () {
	  return this.getDisplayName();
	};
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * FeatureSet class for Store Locator library. A mutable, ordered set of
	 * storeLocator.Features.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A mutable, ordered set of <code>storeLocator.Feature</code>s.
	 * @example <pre>
	 * var feature1 = new storeLocator.Feature('1', 'Feature One');
	 * var feature2 = new storeLocator.Feature('2', 'Feature Two');
	 * var feature3 = new storeLocator.Feature('3', 'Feature Three');
	 *
	 * var featureSet = new storeLocator.FeatureSet(feature1, feature2, feature3);
	 * </pre>
	 * @param {...storeLocator.Feature} var_args the initial features to add to
	 * the set.
	 * @constructor
	 * @implements storeLocator_FeatureSet
	 */
	storeLocator.FeatureSet = function (var_args) {
	  /**
	   * Stores references to the actual Feature.
	   * @private
	   * @type {!Array.<storeLocator.Feature>}
	   */
	  this.array_ = [];
	
	  /**
	   * Maps from a Feature's id to its array index.
	   * @private
	   * @type {Object.<string, number>}
	   */
	  this.hash_ = {};
	
	  for (var i = 0, feature; feature = arguments[i]; i++) {
	    this.add(feature);
	  }
	};
	storeLocator['FeatureSet'] = storeLocator.FeatureSet;
	
	/**
	 * Adds the given feature to the set, if it doesn't exist in the set already.
	 * Else, removes the feature from the set.
	 * @param {!storeLocator.Feature} feature the feature to toggle.
	 */
	storeLocator.FeatureSet.prototype.toggle = function (feature) {
	  if (this.contains(feature)) {
	    this.remove(feature);
	  } else {
	    this.add(feature);
	  }
	};
	
	/**
	 * Check if a feature exists within this set.
	 * @param {!storeLocator.Feature} feature the feature.
	 * @return {boolean} true if the set contains the given feature.
	 */
	storeLocator.FeatureSet.prototype.contains = function (feature) {
	  return feature.getId() in this.hash_;
	};
	
	/**
	 * Gets a Feature object from the set, by the feature id.
	 * @param {string} featureId the feature's id.
	 * @return {storeLocator.Feature} the feature, if the set contains it.
	 */
	storeLocator.FeatureSet.prototype.getById = function (featureId) {
	  if (featureId in this.hash_) {
	    return this.array_[this.hash_[featureId]];
	  }
	  return null;
	};
	
	/**
	 * Adds a feature to the set.
	 * @param {storeLocator.Feature} feature the feature to add.
	 */
	storeLocator.FeatureSet.prototype.add = function (feature) {
	  if (!feature) {
	    return;
	  }
	  this.array_.push(feature);
	  this.hash_[feature.getId()] = this.array_.length - 1;
	};
	
	/**
	 * Removes a feature from the set, if it already exists in the set. If it does
	 * not already exist in the set, this function is a no op.
	 * @param {!storeLocator.Feature} feature the feature to remove.
	 */
	storeLocator.FeatureSet.prototype.remove = function (feature) {
	  if (!this.contains(feature)) {
	    return;
	  }
	  this.array_[this.hash_[feature.getId()]] = null;
	  delete this.hash_[feature.getId()];
	};
	
	/**
	 * Get the contents of this set as an Array.
	 * @return {Array.<!storeLocator.Feature>} the features in the set, in the order
	 * they were inserted.
	 */
	storeLocator.FeatureSet.prototype.asList = function () {
	  var filtered = [];
	  for (var i = 0, ii = this.array_.length; i < ii; i++) {
	    var elem = this.array_[i];
	    if (elem !== null) {
	      filtered.push(elem);
	    }
	  }
	  return filtered;
	};
	
	/**
	 * Empty feature set.
	 * @type storeLocator.FeatureSet
	 * @const
	 */
	storeLocator.FeatureSet.NONE = new storeLocator.FeatureSet();
	
	// Copyright 2013 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * Provides access to store data through Google Maps Engine.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A DataFeed where stores are provided by Google Maps Engine.
	 * <p>
	 * Note: the table that contains the stores needs to be publicly accessible.
	 * @example <pre>
	 * var dataFeed = new storeLocator.GMEDataFeed({
	 *   tableId: '12421761926155747447-06672618218968397709',
	 *   apiKey: 'AIzaSyAtunhRg0VTElV-P7n4Agpm9tYlABQDCAM',
	 *   propertiesModifier: function(props) {
	 *     return {
	 *       id: transformId(props.store_id),
	 *       title: props.store_title
	 *     };
	 *   }
	 * });
	 * new storeLocator.View(map, dataFeed);
	 * </pre>
	 * @implements storeLocator.DataFeed
	 * @param {!storeLocator.GMEDataFeedOptions} opts the table ID, API key and
	 * a transformation function for feature/store properties.
	 * @constructor
	 * @implements storeLocator_GMEDataFeed
	 */
	storeLocator.GMEDataFeed = function (opts) {
	  this.tableId_ = opts['tableId'];
	  this.apiKey_ = opts['apiKey'];
	  if (opts['propertiesModifier']) {
	    this.propertiesModifier_ = opts['propertiesModifier'];
	  }
	};
	storeLocator['GMEDataFeed'] = storeLocator.GMEDataFeed;
	
	storeLocator.GMEDataFeed.prototype.getStores = function (bounds, features, callback) {
	
	  // TODO: use features.
	
	  var that = this;
	  var center = bounds.getCenter();
	
	  var where = '(ST_INTERSECTS(geometry, ' + this.boundsToWkt_(bounds) + ')' + ' OR ST_DISTANCE(geometry, ' + this.latLngToWkt_(center) + ') < 20000)';
	
	  var url = 'https://www.googleapis.com/mapsengine/v1/tables/' + this.tableId_ + '/features?callback=?';
	
	  $.getJSON(url, {
	    'key': this.apiKey_,
	    'where': where,
	    'version': 'published',
	    'maxResults': 300
	  }, function (resp) {
	    var stores = that.parse_(resp);
	    that.sortByDistance_(center, stores);
	    callback(stores);
	  });
	};
	
	/**
	 * @private
	 * @param {!google.maps.LatLng} point
	 * @return {string}
	 */
	storeLocator.GMEDataFeed.prototype.latLngToWkt_ = function (point) {
	  return 'ST_POINT(' + point.lng() + ', ' + point.lat() + ')';
	};
	
	/**
	 * @private
	 * @param {!google.maps.LatLngBounds} bounds
	 * @return {string}
	 */
	storeLocator.GMEDataFeed.prototype.boundsToWkt_ = function (bounds) {
	  var ne = bounds.getNorthEast();
	  var sw = bounds.getSouthWest();
	  return ["ST_GEOMFROMTEXT('POLYGON ((", sw.lng(), ' ', sw.lat(), ', ', ne.lng(), ' ', sw.lat(), ', ', ne.lng(), ' ', ne.lat(), ', ', sw.lng(), ' ', ne.lat(), ', ', sw.lng(), ' ', sw.lat(), "))')"].join('');
	};
	
	/**
	 * @private
	 * @param {*} data GeoJSON feature set.
	 * @return {!Array.<!storeLocator.Store>}
	 */
	storeLocator.GMEDataFeed.prototype.parse_ = function (data) {
	  if (data['error']) {
	    window.alert(data['error']['message']);
	    return [];
	  }
	  var features = data['features'];
	  if (!features) {
	    return [];
	  }
	  var stores = [];
	  for (var i = 0, row; row = features[i]; i++) {
	    var coordinates = row['geometry']['coordinates'];
	    var position = new google.maps.LatLng(coordinates[1], coordinates[0]);
	
	    var props = this.propertiesModifier_(row['properties']);
	    var store = new storeLocator.Store(props['id'], position, null, props);
	    stores.push(store);
	  }
	  return stores;
	};
	
	/**
	 * Default properties modifier. Just returns the same properties passed into
	 * it. Useful if the columns in the GME table are already appropriate.
	 * @private
	 * @param {Object} props
	 * @return {Object} an Object to be passed into the "props" argument in the
	 * Store constructor.
	 */
	storeLocator.GMEDataFeed.prototype.propertiesModifier_ = function (props) {
	  return props;
	};
	
	/**
	 * Sorts a list of given stores by distance from a point in ascending order.
	 * Directly manipulates the given array (has side effects).
	 * @private
	 * @param {google.maps.LatLng} latLng the point to sort from.
	 * @param {!Array.<!storeLocator.Store>} stores  the stores to sort.
	 */
	storeLocator.GMEDataFeed.prototype.sortByDistance_ = function (latLng, stores) {
	  stores.sort(function (a, b) {
	    return a.distanceTo(latLng) - b.distanceTo(latLng);
	  });
	};
	
	/**
	 * @example see storeLocator.GMEDataFeed
	 * @interface
	 */
	storeLocator.GMEDataFeedOptions = function () {};
	
	/**
	 * The table's asset ID.
	 * @type string
	 */
	storeLocator.GMEDataFeedOptions.prototype.tableId;
	
	/**
	 * The API key to use for all requests.
	 * @type string
	 */
	storeLocator.GMEDataFeedOptions.prototype.apiKey;
	
	/**
	 * A transformation function. The first argument is the feature's properties.
	 * Return an object useful for the <code>"props"</code> argument in the
	 * storeLocator.Store constructor. The default properties modifier
	 * function passes the feature straight through.
	 * <p>
	 * Note: storeLocator.GMEDataFeed expects an <code>"id"</code> property.
	 * @type ?(function(Object): Object)
	 */
	storeLocator.GMEDataFeedOptions.prototype.propertiesModifier;
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * An info panel, which complements the map view of the Store Locator.
	 * Provides a list of stores, location search, feature filter, and directions.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * An info panel, to complement the map view.
	 * Provides a list of stores, location search, feature filter, and directions.
	 * @example <pre>
	 * var container = document.getElementById('panel');
	 * var panel = new storeLocator.Panel(container, {
	 *   view: view,
	 *   locationSearchLabel: 'Location:'
	 * });
	 * google.maps.event.addListener(panel, 'geocode', function(result) {
	 *   geocodeMarker.setPosition(result.geometry.location);
	 * });
	 * </pre>
	 * @extends {google.maps.MVCObject}
	 * @param {!Node} el the element to contain this panel.
	 * @param {storeLocator.PanelOptions} opt_options
	 * @constructor
	 * @implements storeLocator_Panel
	 */
	storeLocator.Panel = function (el, opt_options) {
	  this.el_ = $(el);
	  this.el_.addClass('storelocator-panel');
	  this.settings_ = $.extend({
	    'locationSearch': true,
	    'locationSearchLabel': 'Where are you?',
	    'featureFilter': true,
	    'directions': true,
	    'view': null,
	    'start': false
	  }, opt_options);
	
	  this.directionsRenderer_ = new google.maps.DirectionsRenderer({
	    draggable: true
	  });
	  this.directionsService_ = new google.maps.DirectionsService();
	
	  this.init_();
	};
	storeLocator['Panel'] = storeLocator.Panel;
	
	storeLocator.Panel.prototype = new google.maps.MVCObject();
	
	/**
	 * Initialise the info panel
	 * @private
	 */
	storeLocator.Panel.prototype.init_ = function () {
	  var that = this;
	  this.itemCache_ = {};
	
	  if (this.settings_['view']) {
	    this.set('view', this.settings_['view']);
	  }
	
	  this.panel_ = $(document.getElementById('panel-template').innerHTML);
	  this.panel_.appendTo(this.el_);
	
	  if (this.settings_['locationSearch']) {
	
	    if (typeof google.maps.places != 'undefined') {
	      this.initAutocomplete_();
	    }
	    // search form submit
	    $('.js-search').on('submit', function (e) {
	      e.preventDefault();
	      var search = $('.js-search-input').val();
	      that.searchPosition(search);
	    });
	
	    google.maps.event.addListener(this, 'geocode', function (place) {
	      if (!place.geometry) {
	        that.searchPosition(place.name);
	        return;
	      }
	
	      this.directionsFrom_ = place.geometry.location;
	
	      if (that.directionsVisible_) {
	        that.renderDirections_();
	      }
	      var sl = that.get('view');
	      sl.highlight(null);
	      var map = sl.getMap();
	      if (place.geometry.viewport) {
	        map.fitBounds(place.geometry.viewport);
	      } else {
	        map.setCenter(place.geometry.location);
	        map.setZoom(13);
	      }
	      sl.refreshView();
	      that.listenForStoresUpdate_();
	    });
	  }
	
	  this.featureFilter_ = this.panel_.find('.js-filters');
	  if (this.settings_['featureFilter']) {
	    var allFeatures = this.get('view').getFeatures().asList();
	    var filters = [];
	    for (var i = 0; i < allFeatures.length; i++) {
	      var feature = allFeatures[i];
	      var featureString = document.getElementById('template-filter').innerHTML;
	      featureString = featureString.replace(/{index}/g, i);
	      featureString = featureString.replace(/{slug}/g, feature.id_);
	      featureString = featureString.replace(/{name}/g, feature.getDisplayName());
	      this.featureFilter_.append(featureString);
	    }
	    this.panel_.find('input.js-filter-input').change(function () {
	      var feature = allFeatures[$(this).data('index')];
	      that.toggleFeatureFilter_( /** @type {storeLocator.Feature} */feature);
	      that.get('view').refreshView();
	    });
	  }
	
	  this.storeList_ = this.panel_.find('.js-stores');
	
	  if (this.settings_['directions']) {
	    this.directionsPanel_ = this.panel_.find('.js-directions');
	    this.directionsPanel_.find('.directions-to').attr('readonly', 'readonly');
	    this.directionsPanel_.hide();
	    this.directionsVisible_ = false;
	    $('.js-directions form').on('submit', function (e) {
	      e.preventDefault();
	      that.renderDirections_();
	    });
	    this.directionsPanel_.find('.close-directions').click(function () {
	      that.hideDirections();
	    });
	  }
	};
	
	/**
	 * Toggles a particular feature on/off in the feature filter.
	 * @param {storeLocator.Feature} feature The feature to toggle.
	 * @private
	 */
	storeLocator.Panel.prototype.toggleFeatureFilter_ = function (feature) {
	  var featureFilter = this.get('featureFilter');
	  featureFilter.toggle(feature);
	  this.set('featureFilter', featureFilter);
	};
	
	/**
	 * Global Geocoder instance, for convenience.
	 * @type {google.maps.Geocoder}
	 * @private
	 */
	storeLocator.geocoder_ = new google.maps.Geocoder();
	
	/**
	 * Triggers an update for the store list in the Panel. Will wait for stores
	 * to load asynchronously from the data source.
	 * @private
	 */
	storeLocator.Panel.prototype.listenForStoresUpdate_ = function () {
	  var that = this;
	  var view = /** @type storeLocator.View */this.get('view');
	  if (this.storesChangedListener_) {
	    google.maps.event.removeListener(this.storesChangedListener_);
	  }
	  this.storesChangedListener_ = google.maps.event.addListenerOnce(view, 'stores_changed', function () {
	    that.set('stores', view.get('stores'));
	  });
	};
	/**
	 * Search and pan to the specified address.
	 * @param {string} searchText the address to pan to.
	 */
	storeLocator.Panel.prototype.searchPosition = function (searchText) {
	  var that = this;
	  var request = {
	    address: searchText,
	    bounds: this.get('view').getMap().getBounds()
	  };
	  storeLocator.geocoder_.geocode(request, function (result, status) {
	    if (status != google.maps.GeocoderStatus.OK) {
	      //TODO(cbro): proper error handling
	      return;
	    }
	    google.maps.event.trigger(that, 'geocode', result[0]);
	  });
	};
	
	/**
	 * Sets the associated View.
	 * @param {storeLocator.View} view the view to set.
	 */
	storeLocator.Panel.prototype.setView = function (view) {
	  this.set('view', view);
	};
	
	/**
	 * view_changed handler.
	 * Sets up additional bindings between the info panel and the map view.
	 */
	storeLocator.Panel.prototype.view_changed = function () {
	  var sl = /** @type {google.maps.MVCObject} */this.get('view');
	  this.bindTo('selectedStore', sl);
	
	  var that = this;
	  if (this.geolocationListener_) {
	    google.maps.event.removeListener(this.geolocationListener_);
	  }
	  if (this.zoomListener_) {
	    google.maps.event.removeListener(this.zoomListener_);
	  }
	  if (this.idleListener_) {
	    google.maps.event.removeListener(this.idleListener_);
	  }
	
	  var center = sl.getMap().getCenter();
	
	  var updateList = function updateList() {
	    sl.clearMarkers();
	    that.listenForStoresUpdate_();
	  };
	
	  //TODO(cbro): somehow get the geolocated position and populate the 'from' box.
	  this.geolocationListener_ = google.maps.event.addListener(sl, 'load', updateList);
	
	  this.zoomListener_ = google.maps.event.addListener(sl.getMap(), 'zoom_changed', updateList);
	
	  this.idleListener_ = google.maps.event.addListener(sl.getMap(), 'idle', function () {
	    return that.idle_(sl.getMap());
	  });
	
	  updateList();
	  this.bindTo('featureFilter', sl);
	
	  if (this.autoComplete_) {
	    this.autoComplete_.bindTo('bounds', sl.getMap());
	  }
	};
	
	/**
	 * Adds autocomplete to the input box.
	 * @private
	 */
	storeLocator.Panel.prototype.initAutocomplete_ = function () {
	  var that = this;
	  var input = document.getElementById('search-input');
	  this.autoComplete_ = new google.maps.places.Autocomplete(input);
	  if (this.get('view')) {
	    this.autoComplete_.bindTo('bounds', this.get('view').getMap());
	  }
	  google.maps.event.addListener(this.autoComplete_, 'place_changed', function () {
	    google.maps.event.trigger(that, 'geocode', this.getPlace());
	  });
	};
	
	/**
	 * Called on the view's map idle event. Refreshes the store list if the
	 * user has navigated far away enough.
	 * @param {google.maps.Map} map the current view's map.
	 * @private
	 */
	storeLocator.Panel.prototype.idle_ = function (map) {
	  if (!this.center_) {
	    this.center_ = map.getCenter();
	  } else if (!map.getBounds().contains(this.center_)) {
	    this.center_ = map.getCenter();
	    this.listenForStoresUpdate_();
	  }
	};
	
	/**
	 * @const
	 * @type {string}
	 * @private
	 */
	storeLocator.Panel.NO_STORES_HTML_ = document.getElementById('template-stores-none').innerHTML;
	
	/**
	 * @const
	 * @type {string}
	 * @private
	 */
	storeLocator.Panel.NO_STORES_IN_VIEW_HTML_ = document.getElementById('template-stores-none-view').innerHTML;
	
	/**
	 * Handler for stores_changed. Updates the list of stores.
	 * @this storeLocator.Panel
	 */
	storeLocator.Panel.prototype.stores_changed = function () {
	  if (!this.get('stores')) {
	    return;
	  }
	
	  var view = this.get('view');
	  var bounds = view && view.getMap().getBounds();
	
	  var that = this;
	  var stores = this.get('stores');
	  var selectedStore = this.get('selectedStore');
	  this.storeList_.empty();
	
	  if (!stores.length) {
	    this.storeList_.append(storeLocator.Panel.NO_STORES_HTML_);
	  } else if (bounds && !bounds.contains(stores[0].getLocation())) {
	    this.storeList_.append(storeLocator.Panel.NO_STORES_IN_VIEW_HTML_);
	  }
	
	  var clickHandler = function clickHandler() {
	    window.scrollTo(0, 0);
	    view.highlight(this['store'], true);
	  };
	
	  // TODO(cbro): change 10 to a setting/option
	  for (var i = 0, ii = Math.min(10, stores.length); i < ii; i++) {
	    var storeLi = stores[i].getInfoPanelItem();
	    storeLi['store'] = stores[i];
	    if (selectedStore && stores[i].getId() == selectedStore.getId()) {
	      $(storeLi).addClass('highlighted');
	    }
	
	    if (!storeLi.clickHandler_) {
	      storeLi.clickHandler_ = google.maps.event.addDomListener(storeLi, 'click', clickHandler);
	    }
	
	    that.storeList_.append(storeLi);
	  }
	};
	
	/**
	 * Handler for selectedStore_changed. Highlights the selected store in the
	 * store list.
	 * @this storeLocator.Panel
	 */
	storeLocator.Panel.prototype.selectedStore_changed = function () {
	  $('.highlighted', this.storeList_).removeClass('highlighted');
	
	  var that = this;
	  var store = this.get('selectedStore');
	  if (!store) {
	    return;
	  }
	  this.directionsTo_ = store;
	  this.storeList_.find('#store-' + store.getId()).addClass('highlighted');
	
	  if (this.settings_['directions']) {
	    this.directionsPanel_.find('.directions-to').val(store.getDetails().title);
	  }
	
	  var node = that.get('view').getInfoWindow().getContent();
	  var directionsLink = $('<a/>').text('Directions').attr('href', '#').addClass('action').addClass('directions');
	
	  // TODO(cbro): Make these two permanent fixtures in InfoWindow.
	  // Move out of Panel.
	  var zoomLink = $('<a/>').text('Zoom here').attr('href', '#').addClass('action').addClass('zoomhere');
	
	  var streetViewLink = $('<a/>').text('Street view').attr('href', '#').addClass('action').addClass('streetview');
	
	  directionsLink.click(function () {
	    that.showDirections();
	    return false;
	  });
	
	  zoomLink.click(function () {
	    that.get('view').getMap().setOptions({
	      center: store.getLocation(),
	      zoom: 16
	    });
	  });
	
	  streetViewLink.click(function () {
	    var streetView = that.get('view').getMap().getStreetView();
	    streetView.setPosition(store.getLocation());
	    streetView.setVisible(true);
	  });
	
	  $(node).append(directionsLink).append(zoomLink).append(streetViewLink);
	};
	
	/**
	 * Hides the directions panel.
	 */
	storeLocator.Panel.prototype.hideDirections = function () {
	  this.directionsVisible_ = false;
	  this.directionsPanel_.fadeOut();
	  $('.js-filter').slideDown();
	  this.storeList_.fadeIn();
	  this.directionsRenderer_.setMap(null);
	};
	
	/**
	 * Shows directions to the selected store.
	 */
	storeLocator.Panel.prototype.showDirections = function () {
	  var store = this.get('selectedStore');
	  $('.js-filter').slideUp();
	  this.storeList_.slideUp();
	  this.directionsPanel_.find('.directions-to').val(store.getDetails().title);
	  this.directionsPanel_.fadeIn();
	  this.renderDirections_();
	
	  this.directionsVisible_ = true;
	};
	
	/**
	 * Renders directions from the location in the input box, to the store that is
	 * pre-filled in the 'to' box.
	 * @private
	 */
	storeLocator.Panel.prototype.renderDirections_ = function () {
	  var that = this;
	  if (!this.directionsFrom_ || !this.directionsTo_) {
	    return;
	  }
	  var rendered = this.directionsPanel_.find('.rendered-directions').empty();
	
	  this.directionsService_.route({
	    origin: this.directionsFrom_,
	    destination: this.directionsTo_.getLocation(),
	    travelMode: google.maps['DirectionsTravelMode'].DRIVING
	    //TODO(cbro): region biasing, waypoints, travelmode
	  }, function (result, status) {
	    if (status != google.maps.DirectionsStatus.OK) {
	      // TODO(cbro): better error handling
	      return;
	    }
	
	    var renderer = that.directionsRenderer_;
	    renderer.setPanel(rendered[0]);
	    renderer.setMap(that.get('view').getMap());
	    renderer.setDirections(result);
	  });
	};
	
	/**
	 * featureFilter_changed event handler.
	 */
	storeLocator.Panel.prototype.featureFilter_changed = function () {
	  this.listenForStoresUpdate_();
	};
	
	/**
	 * Fired when searchPosition has been called. This happens when the user has
	 * searched for a location from the location search box and/or autocomplete.
	 * @name storeLocator.Panel#event:geocode
	 * @param {google.maps.PlaceResult|google.maps.GeocoderResult} result
	 * @event
	 */
	
	/**
	 * Fired when the <code>Panel</code>'s <code>view</code> property changes.
	 * @name storeLocator.Panel#event:view_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>Panel</code>'s <code>featureFilter</code> property
	 * changes.
	 * @name storeLocator.Panel#event:featureFilter_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>Panel</code>'s <code>stores</code> property changes.
	 * @name storeLocator.Panel#event:stores_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>Panel</code>'s <code>selectedStore</code> property
	 * changes.
	 * @name storeLocator.Panel#event:selectedStore_changed
	 * @event
	 */
	
	/**
	 * @example see storeLocator.Panel
	 * @interface
	 */
	storeLocator.PanelOptions = function () {};
	
	/**
	 * Whether to show the location search box. Default is true.
	 * @type boolean
	 */
	storeLocator.prototype.locationSearch;
	
	/**
	 * The label to show above the location search box. Default is "Where are you
	 * now?".
	 * @type string
	 */
	storeLocator.PanelOptions.prototype.locationSearchLabel;
	
	/**
	 * Whether to show the feature filter picker. Default is true.
	 * @type boolean
	 */
	storeLocator.PanelOptions.prototype.featureFilter;
	
	/**
	 * Whether to provide directions. Deafult is true.
	 * @type boolean
	 */
	storeLocator.PanelOptions.prototype.directions;
	
	/**
	 * The store locator model to bind to.
	 * @type storeLocator.View
	 */
	storeLocator.PanelOptions.prototype.view;
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * Allows developers to specify a static set of stores to be used in the
	 * storelocator.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A DataFeed with a static set of stores. Provides sorting of stores by
	 * proximity and feature filtering (store must have <em>all</em> features from
	 * the filter).
	 * @example <pre>
	 * var dataFeed = new storeLocator.StaticDataFeed();
	 * jQuery.getJSON('stores.json', function(json) {
	 *   var stores = parseStores(json);
	 *   dataFeed.setStores(stores);
	 * });
	 * new storeLocator.View(map, dataFeed);
	 * </pre>
	 * @implements {storeLocator.DataFeed}
	 * @constructor
	 * @implements storeLocator_StaticDataFeed
	 */
	storeLocator.StaticDataFeed = function () {
	  /**
	   * The static list of stores.
	   * @private
	   * @type {Array.<storeLocator.Store>}
	   */
	  this.stores_ = [];
	};
	storeLocator['StaticDataFeed'] = storeLocator.StaticDataFeed;
	
	/**
	 * This will contain a callback to be called if getStores was called before
	 * setStores (i.e. if the map is waiting for data from the data source).
	 * @private
	 * @type {Function}
	 */
	storeLocator.StaticDataFeed.prototype.firstCallback_;
	
	/**
	 * Set the stores for this data feed.
	 * @param {!Array.<!storeLocator.Store>} stores  the stores for this data feed.
	 */
	storeLocator.StaticDataFeed.prototype.setStores = function (stores) {
	  this.stores_ = stores;
	  if (this.firstCallback_) {
	    this.firstCallback_();
	  } else {
	    delete this.firstCallback_;
	  }
	};
	
	/**
	 * @inheritDoc
	 */
	storeLocator.StaticDataFeed.prototype.getStores = function (bounds, features, callback) {
	
	  // Prevent race condition - if getStores is called before stores are loaded.
	  if (!this.stores_.length) {
	    var that = this;
	    this.firstCallback_ = function () {
	      that.getStores(bounds, features, callback);
	    };
	    return;
	  }
	
	  // Filter stores for features.
	  var stores = [];
	  for (var i = 0, store; store = this.stores_[i]; i++) {
	    if (store.hasAllFeatures(features)) {
	      stores.push(store);
	    }
	  }
	  this.sortByDistance_(bounds.getCenter(), stores);
	  callback(stores);
	};
	
	/**
	 * Sorts a list of given stores by distance from a point in ascending order.
	 * Directly manipulates the given array (has side effects).
	 * @private
	 * @param {google.maps.LatLng} latLng the point to sort from.
	 * @param {!Array.<!storeLocator.Store>} stores  the stores to sort.
	 */
	storeLocator.StaticDataFeed.prototype.sortByDistance_ = function (latLng, stores) {
	  stores.sort(function (a, b) {
	    return a.distanceTo(latLng) - b.distanceTo(latLng);
	  });
	};
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * Store model class for Store Locator library.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Represents a store.
	 * @example <pre>
	 * var latLng = new google.maps.LatLng(40.7585, -73.9861);
	 * var store = new storeLocator.Store('times_square', latLng, null);
	 * </pre>
	 * <pre>
	 * var features = new storeLocator.FeatureSet(
	 *     view.getFeatureById('24hour'),
	 *     view.getFeatureById('express'),
	 *     view.getFeatureById('wheelchair_access'));
	 *
	 * var store = new storeLocator.Store('times_square', latLng, features, {
	 *   title: 'Times Square',
	 *   address: '1 Times Square&lt;br>Manhattan, NY 10036'
	 * });
	 * </pre>
	 * <pre>
	 * store.distanceTo(map.getCenter());
	 *
	 * // override default info window
	 * store.getInfoWindowContent = function() {
	 *   var details = this.getDetails();
	 *   return '&lt;h1>' + details.title + '&lt;h1>' + details.address;
	 * };
	 * </pre>
	 * @param {string} id globally unique id of the store - should be suitable to
	 * use as a HTML id.
	 * @param {!google.maps.LatLng} location location of the store.
	 * @param {storeLocator.FeatureSet} features the features of this store.
	 * @param {Object.<string, *>=} props any additional properties.
	 * <p> Recommended fields are:
	 *      'title', 'address', 'phone', 'misc', 'web'. </p>
	 * @constructor
	 * @implements storeLocator_Store
	 */
	storeLocator.Store = function (id, location, features, props) {
	  this.id_ = id;
	  this.location_ = location;
	  this.features_ = features || storeLocator.FeatureSet.NONE;
	  this.props_ = props || {};
	};
	storeLocator['Store'] = storeLocator.Store;
	
	/**
	 * Sets this store's Marker.
	 * @param {google.maps.Marker} marker the marker to set on this store.
	 */
	storeLocator.Store.prototype.setMarker = function (marker) {
	  this.marker_ = marker;
	  google.maps.event.trigger(this, 'marker_changed', marker);
	};
	
	/**
	 * Gets this store's Marker
	 * @return {google.maps.Marker} the store's marker.
	 */
	storeLocator.Store.prototype.getMarker = function () {
	  return this.marker_;
	};
	
	/**
	 * Gets this store's ID.
	 * @return {string} this store's ID.
	 */
	storeLocator.Store.prototype.getId = function () {
	  return this.id_;
	};
	
	/**
	 * Gets this store's location.
	 * @return {google.maps.LatLng} this store's location.
	 */
	storeLocator.Store.prototype.getLocation = function () {
	  return this.location_;
	};
	
	/**
	 * Gets this store's features.
	 * @return {storeLocator.FeatureSet} this store's features.
	 */
	storeLocator.Store.prototype.getFeatures = function () {
	  return this.features_;
	};
	
	/**
	 * Checks whether this store has a particular feature.
	 * @param {!storeLocator.Feature} feature the feature to check for.
	 * @return {boolean} true if the store has the feature, false otherwise.
	 */
	storeLocator.Store.prototype.hasFeature = function (feature) {
	  return this.features_.contains(feature);
	};
	
	/**
	 * Checks whether this store has all the given features.
	 * @param {storeLocator.FeatureSet} features the features to check for.
	 * @return {boolean} true if the store has all features, false otherwise.
	 */
	storeLocator.Store.prototype.hasAllFeatures = function (features) {
	  if (!features) {
	    return true;
	  }
	  var featureList = features.asList();
	  for (var i = 0, ii = featureList.length; i < ii; i++) {
	    if (!this.hasFeature(featureList[i])) {
	      return false;
	    }
	  }
	  return true;
	};
	
	/**
	 * Gets additional details about this store.
	 * @return {Object} additional properties of this store.
	 */
	storeLocator.Store.prototype.getDetails = function () {
	  return this.props_;
	};
	
	/**
	 * Generates HTML for additional details about this store.
	 * @private
	 * @param {Array.<string>} fields the optional fields of this store to output.
	 * @return {string} html version of additional fields of this store.
	 */
	storeLocator.Store.prototype.generateFieldsHTML_ = function (fields, id) {
	  var html = document.getElementById('template-store').innerHTML;
	
	  var address = this.props_.city + ', ';
	  if (this.props_.region) address += this.props_.region + ', ';
	  address += this.props_.country;
	  var products = [];
	  for (var i = 0; i < this.features_.array_.length; i++) {
	    products.push(this.features_.array_[i].name_);
	  }
	
	  html = html.replace('{index}', id);
	  html = html.replace('{title}', this.props_.name);
	  html = html.replace('{address}', address);
	  html = html.replace('{phone}', this.props_.phone).replace('<p class="map__panel__store__phone">null</p>', '');
	  html = html.replace('{products}', products.join(', '));
	  return html;
	};
	
	/**
	 * Generates a HTML list of this store's features.
	 * @private
	 * @return {string} html list of this store's features.
	 */
	storeLocator.Store.prototype.generateFeaturesHTML_ = function () {
	  var html = [];
	  html.push('<ul class="features">');
	  var featureList = this.features_.asList();
	  for (var i = 0, feature; feature = featureList[i]; i++) {
	    html.push('<li>');
	    html.push(feature.getDisplayName());
	    html.push('</li>');
	  }
	  html.push('</ul>');
	  return html.join('');
	};
	
	/**
	 * Gets the HTML content for this Store, suitable for use in an InfoWindow.
	 * @return {string} a HTML version of this store.
	 * CHANGED FROM ORIGINAL PLUGIN BY CHARLOTTE
	 */
	storeLocator.Store.prototype.getInfoWindowContent = function (id) {
	  if (!this.content_) {
	    var fields = ['name', 'city', 'region', 'country'];
	    var html = this.generateFieldsHTML_(fields, id);
	    this.content_ = html;
	  }
	  return this.content_;
	};
	
	/**
	 * Gets the HTML content for this Store, suitable for use in suitable for use
	 * in the sidebar info panel.
	 * @this storeLocator.Store
	 * @return {string} a HTML version of this store.
	 */
	storeLocator.Store.prototype.getInfoPanelContent = function (id) {
	  return this.getInfoWindowContent(id);
	};
	
	/**
	 * Keep a cache of InfoPanel items (DOM Node), keyed by the store ID.
	 * @private
	 * @type {Object}
	 */
	storeLocator.Store.infoPanelCache_ = {};
	
	/**
	 * Gets a HTML element suitable for use in the InfoPanel.
	 * @return {Node} a HTML element.
	 */
	storeLocator.Store.prototype.getInfoPanelItem = function () {
	  var cache = storeLocator.Store.infoPanelCache_;
	  var store = this;
	  var key = store.getId();
	  if (!cache[key]) {
	    cache[key] = $(store.getInfoPanelContent(key))[0];
	  }
	  return cache[key];
	};
	
	/**
	 * Gets the distance between this Store and a certain location.
	 * @param {google.maps.LatLng} point the point to calculate distance to/from.
	 * @return {number} the distance from this store to a given point.
	 * @license
	 *  Latitude/longitude spherical geodesy formulae & scripts
	 *  (c) Chris Veness 2002-2010
	 *  www.movable-type.co.uk/scripts/latlong.html
	 */
	storeLocator.Store.prototype.distanceTo = function (point) {
	  var R = 6371; // mean radius of earth
	  var location = this.getLocation();
	  var lat1 = storeLocator.toRad_(location.lat());
	  var lon1 = storeLocator.toRad_(location.lng());
	  var lat2 = storeLocator.toRad_(point.lat());
	  var lon2 = storeLocator.toRad_(point.lng());
	  var dLat = lat2 - lat1;
	  var dLon = lon2 - lon1;
	
	  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
	  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  return R * c;
	};
	
	/**
	 * Fired when the <code>Store</code>'s <code>marker</code> property changes.
	 * @name storeLocator.Store#event:marker_changed
	 * @param {google.maps.Marker} marker
	 * @event
	 */
	
	// Copyright 2012 Google Inc.
	
	/**
	 * @author Chris Broadfoot (Google)
	 * @fileoverview
	 * This library makes it easy to create a fully-featured Store Locator for
	 * your business's website.
	 */
	
	/**
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Data feed that returns stores based on a given bounds and a set of features.
	 * @example <pre>
	 * // always returns the same stores
	 * function SimpleStaticFeed(stores) {
	 *   this.stores = stores;
	 * }
	 * SimpleStaticFeed.prototype.getStores = function(bounds, features, callback) {
	 *   callback(this.stores);
	 * };
	 * new storeLocator.View(map, new SimpleStaticFeed());
	 * </pre>
	 * @interface
	 */
	storeLocator.DataFeed = function () {};
	storeLocator['DataFeed'] = storeLocator.DataFeed;
	
	/**
	 * Fetch stores, based on bounds to search within, and features to filter on.
	 * @param {google.maps.LatLngBounds} bounds the bounds to search within.
	 * @param {storeLocator.FeatureSet} features the features to filter on.
	 * @param {function(Array.<!storeLocator.Store>)} callback the callback
	 * function.
	 */
	storeLocator.DataFeed.prototype.getStores = function (bounds, features, callback) {};
	
	/**
	 * The main store locator object.
	 * @example <pre>
	 * new storeLocator.View(map, dataFeed);
	 * </pre>
	 * <pre>
	 * var features = new storeLocator.FeatureSet(feature1, feature2, feature3);
	 * new storeLocator.View(map, dataFeed, {
	 *   markerIcon: 'icon.png',
	 *   features: features,
	 *   geolocation: false
	 * });
	 * </pre>
	 * <pre>
	 * // refresh stores every 10 seconds, regardless of interaction on the map.
	 * var view = new storeLocator.View(map, dataFeed, {
	 *   updateOnPan: false
	 * });
	 * setTimeout(function() {
	 *   view.refreshView();
	 * }, 10000);
	 * </pre>
	 * <pre>
	 * // custom MarkerOptions, by overriding the createMarker method.
	 * view.createMarker = function(store) {
	 *   return new google.maps.Marker({
	 *     position: store.getLocation(),
	 *     icon: store.getDetails().icon,
	 *     title: store.getDetails().title
	 *   });
	 * };
	 * </pre>
	 * @extends {google.maps.MVCObject}
	 * @param {google.maps.Map} map the map to operate upon.
	 * @param {storeLocator.DataFeed} data the data feed to fetch stores from.
	 * @param {storeLocator.ViewOptions} opt_options
	 * @constructor
	 * @implements storeLocator_View
	 */
	storeLocator.View = function (map, data, opt_options) {
	  this.map_ = map;
	  this.data_ = data;
	  this.settings_ = $.extend({
	    'updateOnPan': true,
	    'geolocation': true,
	    'features': new storeLocator.FeatureSet()
	  }, opt_options);
	
	  this.init_();
	  google.maps.event.trigger(this, 'load');
	  this.set('featureFilter', new storeLocator.FeatureSet());
	};
	storeLocator['View'] = storeLocator.View;
	
	storeLocator.View.prototype = new google.maps.MVCObject();
	
	/**
	 * Attempt to perform geolocation and pan to the given location
	 * @private
	 */
	storeLocator.View.prototype.geolocate_ = function () {
	  var that = this;
	  if (window.navigator && navigator.geolocation) {
	    navigator.geolocation.getCurrentPosition(function (pos) {
	      var loc = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
	
	      that.getMap().setCenter(loc);
	      that.getMap().setZoom(11);
	      google.maps.event.trigger(that, 'load');
	    }, undefined, /** @type GeolocationPositionOptions */{
	      maximumAge: 60 * 1000,
	      timeout: 10 * 1000
	    });
	  }
	};
	
	/**
	 * Initialise the View object
	 * @private
	 */
	storeLocator.View.prototype.init_ = function () {
	  if (this.settings_['geolocation']) {
	    this.geolocate_();
	  }
	  this.markerCache_ = {};
	  this.infoWindow_ = new google.maps.InfoWindow();
	
	  var that = this;
	  var map = this.getMap();
	
	  this.set('updateOnPan', this.settings_['updateOnPan']);
	
	  google.maps.event.addListener(this.infoWindow_, 'closeclick', function () {
	    that.highlight(null);
	  });
	
	  google.maps.event.addListener(map, 'click', function () {
	    that.highlight(null);
	    that.infoWindow_.close();
	  });
	};
	
	/**
	 * Adds/remove hooks as appropriate.
	 */
	storeLocator.View.prototype.updateOnPan_changed = function () {
	  if (this.updateOnPanListener_) {
	    google.maps.event.removeListener(this.updateOnPanListener_);
	  }
	
	  if (this.get('updateOnPan') && this.getMap()) {
	    var that = this;
	    var map = this.getMap();
	    this.updateOnPanListener_ = google.maps.event.addListener(map, 'idle', function () {
	      that.refreshView();
	    });
	  }
	};
	
	/**
	 * Add a store to the map.
	 * @param {storeLocator.Store} store the store to add.
	 */
	storeLocator.View.prototype.addStoreToMap = function (store) {
	  var marker = this.getMarker(store);
	  store.setMarker(marker);
	  var that = this;
	
	  marker.clickListener_ = google.maps.event.addListener(marker, 'click', function () {
	    that.highlight(store, false);
	  });
	
	  if (marker.getMap() != this.getMap()) {
	    marker.setMap(this.getMap());
	  }
	};
	
	/**
	 * Create a marker for a store.
	 * @param {storeLocator.Store} store the store to produce a marker for.
	 * @this storeLocator.View
	 * @return {google.maps.Marker} a new marker.
	 * @export
	 */
	storeLocator.View.prototype.createMarker = function (store) {
	  var markerOptions = {
	    position: store.getLocation()
	  };
	  var opt_icon = this.settings_['markerIcon'];
	  if (opt_icon) {
	    markerOptions.icon = opt_icon;
	  }
	  return new google.maps.Marker(markerOptions);
	};
	
	/**
	 * Get a marker for a store. By default, this caches the value from
	 * createMarker(store)
	 * @param {storeLocator.Store} store the store to get the marker from.
	 * @return {google.maps.Marker} the marker.
	 */
	storeLocator.View.prototype.getMarker = function (store) {
	  var cache = this.markerCache_;
	  var key = store.getId();
	  if (!cache[key]) {
	    cache[key] = this['createMarker'](store);
	  }
	  return cache[key];
	};
	
	/**
	 * Get a InfoWindow for a particular store.
	 * @param {storeLocator.Store} store the store.
	 * @return {google.maps.InfoWindow} the store's InfoWindow.
	 */
	storeLocator.View.prototype.getInfoWindow = function (store) {
	  if (!store) {
	    return this.infoWindow_;
	  }
	
	  var div = $(store.getInfoWindowContent());
	  this.infoWindow_.setContent(div[0]);
	  return this.infoWindow_;
	};
	
	/**
	 * Gets all possible features for this View.
	 * @return {storeLocator.FeatureSet} All possible features.
	 */
	storeLocator.View.prototype.getFeatures = function () {
	  return this.settings_['features'];
	};
	
	/**
	 * Gets a feature by its id. Convenience method.
	 * @param {string} id the feature's id.
	 * @return {storeLocator.Feature|undefined} The feature, if the id is valid.
	 * undefined if not.
	 */
	storeLocator.View.prototype.getFeatureById = function (id) {
	  if (!this.featureById_) {
	    this.featureById_ = {};
	    for (var i = 0, feature; feature = this.settings_['features'][i]; i++) {
	      this.featureById_[feature.getId()] = feature;
	    }
	  }
	  return this.featureById_[id];
	};
	
	/**
	 * featureFilter_changed event handler.
	 */
	storeLocator.View.prototype.featureFilter_changed = function () {
	  google.maps.event.trigger(this, 'featureFilter_changed', this.get('featureFilter'));
	
	  if (this.get('stores')) {
	    this.clearMarkers();
	  }
	};
	
	/**
	 * Clears the visible markers on the map.
	 */
	storeLocator.View.prototype.clearMarkers = function () {
	  for (var marker in this.markerCache_) {
	    this.markerCache_[marker].setMap(null);
	    var listener = this.markerCache_[marker].clickListener_;
	    if (listener) {
	      google.maps.event.removeListener(listener);
	    }
	  }
	};
	
	/**
	 * Refresh the map's view. This will fetch new data based on the map's bounds.
	 */
	storeLocator.View.prototype.refreshView = function () {
	  var that = this;
	
	  this.data_.getStores(this.getMap().getBounds(),
	  /** @type {storeLocator.FeatureSet} */this.get('featureFilter'), function (stores) {
	    var oldStores = that.get('stores');
	    if (oldStores) {
	      for (var i = 0, ii = oldStores.length; i < ii; i++) {
	        google.maps.event.removeListener(oldStores[i].getMarker().clickListener_);
	      }
	    }
	    that.set('stores', stores);
	  });
	};
	
	/**
	 * stores_changed event handler.
	 * This will display all new stores on the map.
	 * @this storeLocator.View
	 */
	storeLocator.View.prototype.stores_changed = function () {
	  var stores = this.get('stores');
	  for (var i = 0, store; store = stores[i]; i++) {
	    this.addStoreToMap(store);
	  }
	};
	
	/**
	 * Gets the view's Map.
	 * @return {google.maps.Map} the view's Map.
	 */
	storeLocator.View.prototype.getMap = function () {
	  return this.map_;
	};
	
	/**
	 * Select a particular store.
	 * @param {storeLocator.Store} store the store to highlight.
	 * @param {boolean=} opt_pan if panning to the store on the map is desired.
	 */
	storeLocator.View.prototype.highlight = function (store, opt_pan) {
	  var infoWindow = this.getInfoWindow(store);
	  if (store) {
	    var infoWindow = this.getInfoWindow(store);
	    if (store.getMarker()) {
	      infoWindow.open(this.getMap(), store.getMarker());
	    } else {
	      infoWindow.setPosition(store.getLocation());
	      infoWindow.open(this.getMap());
	    }
	    if (opt_pan) {
	
	      //shift the pan center to centralise info window more:
	      var storeLocation = store.getLocation();
	      var scale = Math.pow(2, this.getMap().getZoom());
	      var offsetLat = storeLocation.lat() + this.getMap().getDiv().offsetHeight / 5 / scale;
	      var panCenter = new google.maps.LatLng(offsetLat, storeLocation.lng(), true);
	
	      this.getMap().panTo(panCenter);
	    }
	    if (this.getMap().getStreetView().getVisible()) {
	      this.getMap().getStreetView().setPosition(store.getLocation());
	    }
	  } else {
	    infoWindow.close();
	  }
	
	  this.set('selectedStore', store);
	};
	
	/**
	 * Re-triggers the selectedStore_changed event with the store as a parameter.
	 * @this storeLocator.View
	 */
	storeLocator.View.prototype.selectedStore_changed = function () {
	  google.maps.event.trigger(this, 'selectedStore_changed', this.get('selectedStore'));
	};
	
	/**
	 * Fired when the <code>View</code> is loaded. This happens once immediately,
	 * then once more if geolocation is successful.
	 * @name storeLocator.View#event:load
	 * @event
	 */
	
	/**
	 * Fired when the <code>View</code>'s <code>featureFilter</code> property
	 * changes.
	 * @name storeLocator.View#event:featureFilter_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>View</code>'s <code>updateOnPan</code> property changes.
	 * @name storeLocator.View#event:updateOnPan_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>View</code>'s <code>stores</code> property changes.
	 * @name storeLocator.View#event:stores_changed
	 * @event
	 */
	
	/**
	 * Fired when the <code>View</code>'s <code>selectedStore</code> property
	 * changes. This happens after <code>highlight()</code> is called.
	 * @name storeLocator.View#event:selectedStore_changed
	 * @param {storeLocator.Store} store
	 * @event
	 */
	
	/**
	 * @example see storeLocator.View
	 * @interface
	 */
	storeLocator.ViewOptions = function () {};
	
	/**
	 * Whether the map should update stores in the visible area when the visible
	 * area changes. <code>refreshView()</code> will need to be called
	 * programatically. Defaults to true.
	 * @type boolean
	 */
	storeLocator.ViewOptions.prototype.updateOnPan;
	
	/**
	 * Whether the store locator should attempt to determine the user's location
	 * for the initial view. Defaults to true.
	 * @type boolean
	 */
	storeLocator.ViewOptions.prototype.geolocation;
	
	/**
	 * All available store features. Defaults to empty FeatureSet.
	 * @type storeLocator.FeatureSet
	 */
	storeLocator.ViewOptions.prototype.features;
	
	/**
	 * The icon to use for markers representing stores.
	 * @type string|google.maps.MarkerImage
	 */
	storeLocator.ViewOptions.prototype.markerIcon;

/***/ },

/***/ 237:
/***/ function(module, exports) {

	// ==ClosureCompiler==
	// @compilation_level ADVANCED_OPTIMIZATIONS
	// @externs_url http://closure-compiler.googlecode.com/svn/trunk/contrib/externs/maps/google_maps_api_v3.js
	// ==/ClosureCompiler==
	
	/**
	 * @name CSS3 InfoBubble with tabs for Google Maps API V3
	 * @version 0.8
	 * @author Luke Mahe
	 * @fileoverview
	 * This library is a CSS Infobubble with tabs. It uses css3 rounded corners and
	 * drop shadows and animations. It also allows tabs
	 */
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * A CSS3 InfoBubble v0.8
	 * @param {Object.<string, *>=} opt_options Optional properties to set.
	 * @extends {google.maps.OverlayView}
	 * @constructor
	 */
	'use strict';
	
	function InfoBubble(opt_options) {
	  this.extend(InfoBubble, google.maps.OverlayView);
	  this.tabs_ = [];
	  this.activeTab_ = null;
	  this.baseZIndex_ = 100;
	  this.isOpen_ = false;
	
	  var options = opt_options || {};
	
	  if (options['backgroundColor'] == undefined) {
	    options['backgroundColor'] = this.BACKGROUND_COLOR_;
	  }
	
	  if (options['borderColor'] == undefined) {
	    options['borderColor'] = this.BORDER_COLOR_;
	  }
	
	  if (options['borderRadius'] == undefined) {
	    options['borderRadius'] = this.BORDER_RADIUS_;
	  }
	
	  if (options['borderWidth'] == undefined) {
	    options['borderWidth'] = this.BORDER_WIDTH_;
	  }
	
	  if (options['padding'] == undefined) {
	    options['padding'] = this.PADDING_;
	  }
	
	  if (options['tabPadding'] == undefined) {
	    options['tabPadding'] == this.TABPADDING_;
	  }
	
	  if (options['arrowPosition'] == undefined) {
	    options['arrowPosition'] = this.ARROW_POSITION_;
	  }
	
	  if (options['disableAutoPan'] == undefined) {
	    options['disableAutoPan'] = false;
	  }
	
	  if (options['disableAnimation'] == undefined) {
	    options['disableAnimation'] = false;
	  }
	
	  if (options['minWidth'] == undefined) {
	    options['minWidth'] = this.MIN_WIDTH_;
	  }
	
	  if (options['maxWidth'] == undefined) {
	    options['maxWidth'] = this.MAX_WIDTH_;
	  }
	
	  if (options['shadowStyle'] == undefined) {
	    options['shadowStyle'] = this.SHADOW_STYLE_;
	  }
	
	  if (options['arrowSize'] == undefined) {
	    options['arrowSize'] = this.ARROW_SIZE_;
	  }
	
	  if (options['arrowStyle'] == undefined) {
	    options['arrowStyle'] = this.ARROW_STYLE_;
	  }
	
	  this.buildDom_();
	
	  this.setValues(options);
	}
	window['InfoBubble'] = InfoBubble;
	
	/**
	 * Default arrow size
	 * @const
	 * @private
	 */
	InfoBubble.prototype.ARROW_SIZE_ = 15;
	
	/**
	 * Default arrow style
	 * @const
	 * @private
	 */
	InfoBubble.prototype.ARROW_STYLE_ = 0;
	
	/**
	 * Default shadow style
	 * @const
	 * @private
	 */
	InfoBubble.prototype.SHADOW_STYLE_ = 1;
	
	/**
	 * Default min width
	 * @const
	 * @private
	 */
	InfoBubble.prototype.MIN_WIDTH_ = 50;
	
	/**
	 * Default max width
	 * @const
	 * @private
	 */
	InfoBubble.prototype.MAX_WIDTH_ = 400;
	
	/**
	 * Default arrow position
	 * @const
	 * @private
	 */
	InfoBubble.prototype.ARROW_POSITION_ = 50;
	
	/**
	 * Default padding
	 * @const
	 * @private
	 */
	InfoBubble.prototype.PADDING_ = 10;
	
	/**
	 * Default tab Padding
	 * @const
	 * @private
	 */
	InfoBubble.prototype.TABPADDING_ = 10;
	
	/**
	 * Default border width
	 * @const
	 * @private
	 */
	InfoBubble.prototype.BORDER_WIDTH_ = 1;
	
	/**
	 * Default border color
	 * @const
	 * @private
	 */
	InfoBubble.prototype.BORDER_COLOR_ = '#ccc';
	
	/**
	 * Default border radius
	 * @const
	 * @private
	 */
	InfoBubble.prototype.BORDER_RADIUS_ = 10;
	
	/**
	 * Default background color
	 * @const
	 * @private
	 */
	InfoBubble.prototype.BACKGROUND_COLOR_ = '#fff';
	
	/**
	 * Extends a objects prototype by anothers.
	 *
	 * @param {Object} obj1 The object to be extended.
	 * @param {Object} obj2 The object to extend with.
	 * @return {Object} The new extended object.
	 * @ignore
	 */
	InfoBubble.prototype.extend = function (obj1, obj2) {
	  return (function (object) {
	    for (var property in object.prototype) {
	      this.prototype[property] = object.prototype[property];
	    }
	    return this;
	  }).apply(obj1, [obj2]);
	};
	
	/**
	 * Builds the InfoBubble dom
	 * @private
	 */
	InfoBubble.prototype.buildDom_ = function () {
	  var bubble = this.bubble_ = document.createElement('DIV');
	  bubble.style['position'] = 'absolute';
	  bubble.style['zIndex'] = this.baseZIndex_;
	
	  var tabsContainer = this.tabsContainer_ = document.createElement('DIV');
	  tabsContainer.style['position'] = 'relative';
	
	  // Close button
	  var close = this.close_ = document.createElement('IMG');
	  close.style['position'] = 'absolute';
	  close.style['width'] = this.px(12);
	  close.style['height'] = this.px(12);
	  close.style['border'] = 0;
	  close.style['zIndex'] = this.baseZIndex_ + 1;
	  close.style['cursor'] = 'pointer';
	  close.src = 'http://maps.gstatic.com/intl/en_us/mapfiles/iw_close.gif';
	
	  var that = this;
	  google.maps.event.addDomListener(close, 'click', function () {
	    that.close();
	    google.maps.event.trigger(that, 'closeclick');
	  });
	
	  // Content area
	  var contentContainer = this.contentContainer_ = document.createElement('DIV');
	  contentContainer.style['overflowX'] = 'auto';
	  contentContainer.style['overflowY'] = 'auto';
	  contentContainer.style['cursor'] = 'default';
	  contentContainer.style['clear'] = 'both';
	  contentContainer.style['position'] = 'relative';
	
	  var content = this.content_ = document.createElement('DIV');
	  contentContainer.appendChild(content);
	
	  // Arrow
	  var arrow = this.arrow_ = document.createElement('DIV');
	  arrow.style['position'] = 'relative';
	
	  var arrowOuter = this.arrowOuter_ = document.createElement('DIV');
	  var arrowInner = this.arrowInner_ = document.createElement('DIV');
	
	  var arrowSize = this.getArrowSize_();
	
	  arrowOuter.style['position'] = arrowInner.style['position'] = 'absolute';
	  arrowOuter.style['left'] = arrowInner.style['left'] = '50%';
	  arrowOuter.style['height'] = arrowInner.style['height'] = '0';
	  arrowOuter.style['width'] = arrowInner.style['width'] = '0';
	  arrowOuter.style['marginLeft'] = this.px(-arrowSize);
	  arrowOuter.style['borderWidth'] = this.px(arrowSize);
	  arrowOuter.style['borderBottomWidth'] = 0;
	
	  // Shadow
	  var bubbleShadow = this.bubbleShadow_ = document.createElement('DIV');
	  bubbleShadow.style['position'] = 'absolute';
	
	  // Hide the InfoBubble by default
	  bubble.style['display'] = bubbleShadow.style['display'] = 'none';
	
	  bubble.appendChild(this.tabsContainer_);
	  bubble.appendChild(close);
	  bubble.appendChild(contentContainer);
	  arrow.appendChild(arrowOuter);
	  arrow.appendChild(arrowInner);
	  bubble.appendChild(arrow);
	
	  var stylesheet = document.createElement('style');
	  stylesheet.setAttribute('type', 'text/css');
	
	  /**
	   * The animation for the infobubble
	   * @type {string}
	   */
	  this.animationName_ = '_ibani_' + Math.round(Math.random() * 10000);
	
	  // edited by Charlotte
	  var css = '.' + this.animationName_ + '{-webkit-animation-name:' + this.animationName_ + ';-webkit-animation-duration:0.3s;' + '-webkit-animation-iteration-count:1; -webkit-transform-origin: 30% 100%; animation-name:' + this.animationName_ + ';animation-duration:0.3s;' + 'animation-iteration-count:1; transform-origin: 30% 100%;}' + '@-webkit-keyframes ' + this.animationName_ + ' {from {' + '-webkit-transform: scale(0)} to {-webkit-transform: scale(1)}}' + '@keyframes ' + this.animationName_ + ' {from {' + 'transform: scale(0)} to {transform: scale(1)}}';
	
	  stylesheet.textContent = css;
	  document.getElementsByTagName('head')[0].appendChild(stylesheet);
	};
	
	/**
	 * Sets the background class name
	 *
	 * @param {string} className The class name to set.
	 */
	InfoBubble.prototype.setBackgroundClassName = function (className) {
	  this.set('backgroundClassName', className);
	};
	InfoBubble.prototype['setBackgroundClassName'] = InfoBubble.prototype.setBackgroundClassName;
	
	/**
	 * changed MVC callback
	 */
	InfoBubble.prototype.backgroundClassName_changed = function () {
	  this.content_.className = this.get('backgroundClassName');
	};
	InfoBubble.prototype['backgroundClassName_changed'] = InfoBubble.prototype.backgroundClassName_changed;
	
	/**
	 * Sets the class of the tab
	 *
	 * @param {string} className the class name to set.
	 */
	InfoBubble.prototype.setTabClassName = function (className) {
	  this.set('tabClassName', className);
	};
	InfoBubble.prototype['setTabClassName'] = InfoBubble.prototype.setTabClassName;
	
	/**
	 * Sets the class of the active Tab
	 *
	 * @param {string} className the class name to set.
	 */
	InfoBubble.prototype.setActiveTabClassName = function (activeTabClassName) {
	  this.set('activeTabClassName', activeTabClassName);
	};
	InfoBubble.prototype['activeTabClassName'] = InfoBubble.prototype.setActiveTabClassName;
	
	/**
	 * tabClassName changed MVC callback
	 */
	InfoBubble.prototype.tabClassName_changed = function () {
	  this.updateTabStyles_();
	};
	InfoBubble.prototype['tabClassName_changed'] = InfoBubble.prototype.tabClassName_changed;
	
	/**
	 * Gets the style of the arrow
	 *
	 * @private
	 * @return {number} The style of the arrow.
	 */
	InfoBubble.prototype.getArrowStyle_ = function () {
	  return parseInt(this.get('arrowStyle'), 10) || 0;
	};
	
	/**
	 * Sets the style of the arrow
	 *
	 * @param {number} style The style of the arrow.
	 */
	InfoBubble.prototype.setArrowStyle = function (style) {
	  this.set('arrowStyle', style);
	};
	InfoBubble.prototype['setArrowStyle'] = InfoBubble.prototype.setArrowStyle;
	
	/**
	 * Arrow style changed MVC callback
	 */
	InfoBubble.prototype.arrowStyle_changed = function () {
	  this.arrowSize_changed();
	};
	InfoBubble.prototype['arrowStyle_changed'] = InfoBubble.prototype.arrowStyle_changed;
	
	/**
	 * Gets the size of the arrow
	 *
	 * @private
	 * @return {number} The size of the arrow.
	 */
	InfoBubble.prototype.getArrowSize_ = function () {
	  return parseInt(this.get('arrowSize'), 10) || 0;
	};
	
	/**
	 * Sets the size of the arrow
	 *
	 * @param {number} size The size of the arrow.
	 */
	InfoBubble.prototype.setArrowSize = function (size) {
	  this.set('arrowSize', size);
	};
	InfoBubble.prototype['setArrowSize'] = InfoBubble.prototype.setArrowSize;
	
	/**
	 * Arrow size changed MVC callback
	 */
	InfoBubble.prototype.arrowSize_changed = function () {
	  this.borderWidth_changed();
	};
	InfoBubble.prototype['arrowSize_changed'] = InfoBubble.prototype.arrowSize_changed;
	
	/**
	 * Set the position of the InfoBubble arrow
	 *
	 * @param {number} pos The position to set.
	 */
	InfoBubble.prototype.setArrowPosition = function (pos) {
	  this.set('arrowPosition', pos);
	};
	InfoBubble.prototype['setArrowPosition'] = InfoBubble.prototype.setArrowPosition;
	
	/**
	 * Get the position of the InfoBubble arrow
	 *
	 * @private
	 * @return {number} The position..
	 */
	InfoBubble.prototype.getArrowPosition_ = function () {
	  return parseInt(this.get('arrowPosition'), 10) || 0;
	};
	
	/**
	 * arrowPosition changed MVC callback
	 */
	InfoBubble.prototype.arrowPosition_changed = function () {
	  var pos = this.getArrowPosition_();
	  this.arrowOuter_.style['left'] = this.arrowInner_.style['left'] = pos + '%';
	
	  this.redraw_();
	};
	InfoBubble.prototype['arrowPosition_changed'] = InfoBubble.prototype.arrowPosition_changed;
	
	/**
	 * Set the zIndex of the InfoBubble
	 *
	 * @param {number} zIndex The zIndex to set.
	 */
	InfoBubble.prototype.setZIndex = function (zIndex) {
	  this.set('zIndex', zIndex);
	};
	InfoBubble.prototype['setZIndex'] = InfoBubble.prototype.setZIndex;
	
	/**
	 * Get the zIndex of the InfoBubble
	 *
	 * @return {number} The zIndex to set.
	 */
	InfoBubble.prototype.getZIndex = function () {
	  return parseInt(this.get('zIndex'), 10) || this.baseZIndex_;
	};
	
	/**
	 * zIndex changed MVC callback
	 */
	InfoBubble.prototype.zIndex_changed = function () {
	  var zIndex = this.getZIndex();
	
	  this.bubble_.style['zIndex'] = this.baseZIndex_ = zIndex;
	  this.close_.style['zIndex'] = zIndex + 1;
	};
	InfoBubble.prototype['zIndex_changed'] = InfoBubble.prototype.zIndex_changed;
	
	/**
	 * Set the style of the shadow
	 *
	 * @param {number} shadowStyle The style of the shadow.
	 */
	InfoBubble.prototype.setShadowStyle = function (shadowStyle) {
	  this.set('shadowStyle', shadowStyle);
	};
	InfoBubble.prototype['setShadowStyle'] = InfoBubble.prototype.setShadowStyle;
	
	/**
	 * Get the style of the shadow
	 *
	 * @private
	 * @return {number} The style of the shadow.
	 */
	InfoBubble.prototype.getShadowStyle_ = function () {
	  return parseInt(this.get('shadowStyle'), 10) || 0;
	};
	
	/**
	 * shadowStyle changed MVC callback
	 */
	InfoBubble.prototype.shadowStyle_changed = function () {
	  var shadowStyle = this.getShadowStyle_();
	
	  var display = '';
	  var shadow = '';
	  var backgroundColor = '';
	  switch (shadowStyle) {
	    case 0:
	      display = 'none';
	      break;
	    case 1:
	      shadow = '40px 15px 10px rgba(33,33,33,0.3)';
	      backgroundColor = 'transparent';
	      break;
	    case 2:
	      shadow = '0 0 2px rgba(33,33,33,0.3)';
	      backgroundColor = 'rgba(33,33,33,0.35)';
	      break;
	  }
	  this.bubbleShadow_.style['boxShadow'] = this.bubbleShadow_.style['webkitBoxShadow'] = this.bubbleShadow_.style['MozBoxShadow'] = shadow;
	  this.bubbleShadow_.style['backgroundColor'] = backgroundColor;
	  if (this.isOpen_) {
	    this.bubbleShadow_.style['display'] = display;
	    this.draw();
	  }
	};
	InfoBubble.prototype['shadowStyle_changed'] = InfoBubble.prototype.shadowStyle_changed;
	
	/**
	 * Show the close button
	 */
	InfoBubble.prototype.showCloseButton = function () {
	  this.set('hideCloseButton', false);
	};
	InfoBubble.prototype['showCloseButton'] = InfoBubble.prototype.showCloseButton;
	
	/**
	 * Hide the close button
	 */
	InfoBubble.prototype.hideCloseButton = function () {
	  this.set('hideCloseButton', true);
	};
	InfoBubble.prototype['hideCloseButton'] = InfoBubble.prototype.hideCloseButton;
	
	/**
	 * hideCloseButton changed MVC callback
	 */
	InfoBubble.prototype.hideCloseButton_changed = function () {
	  this.close_.style['display'] = this.get('hideCloseButton') ? 'none' : '';
	};
	InfoBubble.prototype['hideCloseButton_changed'] = InfoBubble.prototype.hideCloseButton_changed;
	
	/**
	 * Set the background color
	 *
	 * @param {string} color The color to set.
	 */
	InfoBubble.prototype.setBackgroundColor = function (color) {
	  if (color) {
	    this.set('backgroundColor', color);
	  }
	};
	InfoBubble.prototype['setBackgroundColor'] = InfoBubble.prototype.setBackgroundColor;
	
	/**
	 * backgroundColor changed MVC callback
	 */
	InfoBubble.prototype.backgroundColor_changed = function () {
	  var backgroundColor = this.get('backgroundColor');
	  this.contentContainer_.style['backgroundColor'] = backgroundColor;
	
	  this.arrowInner_.style['borderColor'] = backgroundColor + ' transparent transparent';
	  this.updateTabStyles_();
	};
	InfoBubble.prototype['backgroundColor_changed'] = InfoBubble.prototype.backgroundColor_changed;
	
	/**
	 * Set the border color
	 *
	 * @param {string} color The border color.
	 */
	InfoBubble.prototype.setBorderColor = function (color) {
	  if (color) {
	    this.set('borderColor', color);
	  }
	};
	InfoBubble.prototype['setBorderColor'] = InfoBubble.prototype.setBorderColor;
	
	/**
	 * borderColor changed MVC callback
	 */
	InfoBubble.prototype.borderColor_changed = function () {
	  var borderColor = this.get('borderColor');
	
	  var contentContainer = this.contentContainer_;
	  var arrowOuter = this.arrowOuter_;
	  contentContainer.style['borderColor'] = borderColor;
	
	  arrowOuter.style['borderColor'] = borderColor + ' transparent transparent';
	
	  contentContainer.style['borderStyle'] = arrowOuter.style['borderStyle'] = this.arrowInner_.style['borderStyle'] = 'solid';
	
	  this.updateTabStyles_();
	};
	InfoBubble.prototype['borderColor_changed'] = InfoBubble.prototype.borderColor_changed;
	
	/**
	 * Set the radius of the border
	 *
	 * @param {number} radius The radius of the border.
	 */
	InfoBubble.prototype.setBorderRadius = function (radius) {
	  this.set('borderRadius', radius);
	};
	InfoBubble.prototype['setBorderRadius'] = InfoBubble.prototype.setBorderRadius;
	
	/**
	 * Get the radius of the border
	 *
	 * @private
	 * @return {number} The radius of the border.
	 */
	InfoBubble.prototype.getBorderRadius_ = function () {
	  return parseInt(this.get('borderRadius'), 10) || 0;
	};
	
	/**
	 * borderRadius changed MVC callback
	 */
	InfoBubble.prototype.borderRadius_changed = function () {
	  var borderRadius = this.getBorderRadius_();
	  var borderWidth = this.getBorderWidth_();
	
	  this.contentContainer_.style['borderRadius'] = this.contentContainer_.style['MozBorderRadius'] = this.contentContainer_.style['webkitBorderRadius'] = this.bubbleShadow_.style['borderRadius'] = this.bubbleShadow_.style['MozBorderRadius'] = this.bubbleShadow_.style['webkitBorderRadius'] = this.px(borderRadius);
	
	  this.tabsContainer_.style['paddingLeft'] = this.tabsContainer_.style['paddingRight'] = this.px(borderRadius + borderWidth);
	
	  this.redraw_();
	};
	InfoBubble.prototype['borderRadius_changed'] = InfoBubble.prototype.borderRadius_changed;
	
	/**
	 * Get the width of the border
	 *
	 * @private
	 * @return {number} width The width of the border.
	 */
	InfoBubble.prototype.getBorderWidth_ = function () {
	  return parseInt(this.get('borderWidth'), 10) || 0;
	};
	
	/**
	 * Set the width of the border
	 *
	 * @param {number} width The width of the border.
	 */
	InfoBubble.prototype.setBorderWidth = function (width) {
	  this.set('borderWidth', width);
	};
	InfoBubble.prototype['setBorderWidth'] = InfoBubble.prototype.setBorderWidth;
	
	/**
	 * borderWidth change MVC callback
	 */
	InfoBubble.prototype.borderWidth_changed = function () {
	  var borderWidth = this.getBorderWidth_();
	
	  this.contentContainer_.style['borderWidth'] = this.px(borderWidth);
	  this.tabsContainer_.style['top'] = this.px(borderWidth);
	
	  this.updateArrowStyle_();
	  this.updateTabStyles_();
	  this.borderRadius_changed();
	  this.redraw_();
	};
	InfoBubble.prototype['borderWidth_changed'] = InfoBubble.prototype.borderWidth_changed;
	
	/**
	 * Update the arrow style
	 * @private
	 */
	InfoBubble.prototype.updateArrowStyle_ = function () {
	  var borderWidth = this.getBorderWidth_();
	  var arrowSize = this.getArrowSize_();
	  var arrowStyle = this.getArrowStyle_();
	  var arrowOuterSizePx = this.px(arrowSize);
	  var arrowInnerSizePx = this.px(Math.max(0, arrowSize - borderWidth));
	
	  var outer = this.arrowOuter_;
	  var inner = this.arrowInner_;
	
	  this.arrow_.style['marginTop'] = this.px(-borderWidth);
	  outer.style['borderTopWidth'] = arrowOuterSizePx;
	  inner.style['borderTopWidth'] = arrowInnerSizePx;
	
	  // Full arrow or arrow pointing to the left
	  if (arrowStyle == 0 || arrowStyle == 1) {
	    outer.style['borderLeftWidth'] = arrowOuterSizePx;
	    inner.style['borderLeftWidth'] = arrowInnerSizePx;
	  } else {
	    outer.style['borderLeftWidth'] = inner.style['borderLeftWidth'] = 0;
	  }
	
	  // Full arrow or arrow pointing to the right
	  if (arrowStyle == 0 || arrowStyle == 2) {
	    outer.style['borderRightWidth'] = arrowOuterSizePx;
	    inner.style['borderRightWidth'] = arrowInnerSizePx;
	  } else {
	    outer.style['borderRightWidth'] = inner.style['borderRightWidth'] = 0;
	  }
	
	  if (arrowStyle < 2) {
	    outer.style['marginLeft'] = this.px(-arrowSize);
	    inner.style['marginLeft'] = this.px(-(arrowSize - borderWidth));
	  } else {
	    outer.style['marginLeft'] = inner.style['marginLeft'] = 0;
	  }
	};
	
	/**
	 * Set the padding of the InfoBubble
	 *
	 * @param {number} padding The padding to apply.
	 */
	InfoBubble.prototype.setPadding = function (padding) {
	  this.set('padding', padding);
	};
	InfoBubble.prototype['setPadding'] = InfoBubble.prototype.setPadding;
	
	/**
	 * set the padding of the Tab's
	 *
	 * @param {number} padding The padding to apply to the tab
	 */
	InfoBubble.prototype.settabPadding = function (tabPadding) {
	  this.set('tabPadding', tabPadding);
	};
	InfoBubble.prototype['settabPadding'] = InfoBubble.prototype.settabPadding;
	
	/**
	 * Set the padding of the InfoBubble
	 *
	 * @private
	 * @return {number} padding The padding to apply.
	 */
	InfoBubble.prototype.getPadding_ = function () {
	  return parseInt(this.get('padding'), 10) || 0;
	};
	
	InfoBubble.prototype.gettabPadding_ = function () {
	  return parseInt(this.get('tabPadding'), 10) || 0;
	};
	
	/**
	 * padding changed MVC callback
	 */
	InfoBubble.prototype.padding_changed = function () {
	  var padding = this.getPadding_();
	  var tabPadding = this.gettabPadding_();
	  this.contentContainer_.style['padding'] = this.px(padding);
	  this.contentContainer_.style['tabPadding'] = this.px(padding);
	  this.updateTabStyles_();
	
	  this.redraw_();
	};
	InfoBubble.prototype['padding_changed'] = InfoBubble.prototype.padding_changed;
	
	/**
	 * Add px extention to the number
	 *
	 * @param {number} num The number to wrap.
	 * @return {string|number} A wrapped number.
	 */
	InfoBubble.prototype.px = function (num) {
	  if (num) {
	    // 0 doesn't need to be wrapped
	    return num + 'px';
	  }
	  return num;
	};
	
	/**
	 * Add events to stop propagation
	 * @private
	 */
	InfoBubble.prototype.addEvents_ = function () {
	  // We want to cancel all the events so they do not go to the map
	  var events = ['mousedown', 'mousemove', 'mouseover', 'mouseout', 'mouseup', 'mousewheel', 'DOMMouseScroll', 'touchstart', 'touchend', 'touchmove', 'dblclick', 'contextmenu', 'click'];
	
	  var bubble = this.bubble_;
	  this.listeners_ = [];
	  for (var i = 0, event; event = events[i]; i++) {
	    this.listeners_.push(google.maps.event.addDomListener(bubble, event, function (e) {
	      e.cancelBubble = true;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	    }));
	  }
	};
	
	/**
	 * On Adding the InfoBubble to a map
	 * Implementing the OverlayView interface
	 */
	InfoBubble.prototype.onAdd = function () {
	  if (!this.bubble_) {
	    this.buildDom_();
	  }
	
	  this.addEvents_();
	
	  var panes = this.getPanes();
	  if (panes) {
	    panes.floatPane.appendChild(this.bubble_);
	    panes.floatShadow.appendChild(this.bubbleShadow_);
	  }
	};
	InfoBubble.prototype['onAdd'] = InfoBubble.prototype.onAdd;
	
	/**
	 * Draw the InfoBubble
	 * Implementing the OverlayView interface
	 */
	InfoBubble.prototype.draw = function () {
	  var projection = this.getProjection();
	  if (!projection) {
	    // The map projection is not ready yet so do nothing
	    return;
	  }
	
	  var latLng = /** @type {google.maps.LatLng} */this.get('position');
	
	  if (!latLng) {
	    this.close();
	    return;
	  }
	
	  var tabHeight = 0;
	  if (this.activeTab_) {
	    tabHeight = this.activeTab_.offsetHeight;
	  }
	
	  var anchorHeight = this.getAnchorHeight_();
	  var arrowSize = this.getArrowSize_();
	  var arrowPosition = this.getArrowPosition_();
	
	  arrowPosition = arrowPosition / 100;
	
	  var pos = projection.fromLatLngToDivPixel(latLng);
	  var width = this.contentContainer_.offsetWidth;
	  var height = this.bubble_.offsetHeight;
	
	  if (!width) {
	    return;
	  }
	
	  // Adjust for the height of the info bubble
	  var top = pos.y - (height + arrowSize);
	
	  if (anchorHeight) {
	    // If there is an anchor then include the height
	    top -= anchorHeight;
	  }
	
	  var left = pos.x - width * arrowPosition;
	
	  this.bubble_.style['top'] = this.px(top);
	  this.bubble_.style['left'] = this.px(left);
	
	  var shadowStyle = parseInt(this.get('shadowStyle'), 10);
	
	  switch (shadowStyle) {
	    case 1:
	      // Shadow is behind
	      this.bubbleShadow_.style['top'] = this.px(top + tabHeight - 1);
	      this.bubbleShadow_.style['left'] = this.px(left);
	      this.bubbleShadow_.style['width'] = this.px(width);
	      this.bubbleShadow_.style['height'] = this.px(this.contentContainer_.offsetHeight - arrowSize);
	      break;
	    case 2:
	      // Shadow is below
	      width = width * 0.8;
	      if (anchorHeight) {
	        this.bubbleShadow_.style['top'] = this.px(pos.y);
	      } else {
	        this.bubbleShadow_.style['top'] = this.px(pos.y + arrowSize);
	      }
	      this.bubbleShadow_.style['left'] = this.px(pos.x - width * arrowPosition);
	
	      this.bubbleShadow_.style['width'] = this.px(width);
	      this.bubbleShadow_.style['height'] = this.px(2);
	      break;
	  }
	};
	InfoBubble.prototype['draw'] = InfoBubble.prototype.draw;
	
	/**
	 * Removing the InfoBubble from a map
	 */
	InfoBubble.prototype.onRemove = function () {
	  if (this.bubble_ && this.bubble_.parentNode) {
	    this.bubble_.parentNode.removeChild(this.bubble_);
	  }
	  if (this.bubbleShadow_ && this.bubbleShadow_.parentNode) {
	    this.bubbleShadow_.parentNode.removeChild(this.bubbleShadow_);
	  }
	
	  for (var i = 0, listener; listener = this.listeners_[i]; i++) {
	    google.maps.event.removeListener(listener);
	  }
	};
	InfoBubble.prototype['onRemove'] = InfoBubble.prototype.onRemove;
	
	/**
	 * Is the InfoBubble open
	 *
	 * @return {boolean} If the InfoBubble is open.
	 */
	InfoBubble.prototype.isOpen = function () {
	  return this.isOpen_;
	};
	InfoBubble.prototype['isOpen'] = InfoBubble.prototype.isOpen;
	
	/**
	 * Close the InfoBubble
	 */
	InfoBubble.prototype.close = function () {
	  if (this.bubble_) {
	    this.bubble_.style['display'] = 'none';
	    // Remove the animation so we next time it opens it will animate again
	    this.bubble_.className = this.bubble_.className.replace(this.animationName_, '');
	  }
	
	  if (this.bubbleShadow_) {
	    this.bubbleShadow_.style['display'] = 'none';
	    this.bubbleShadow_.className = this.bubbleShadow_.className.replace(this.animationName_, '');
	  }
	  this.isOpen_ = false;
	};
	InfoBubble.prototype['close'] = InfoBubble.prototype.close;
	
	/**
	 * Open the InfoBubble (asynchronous).
	 *
	 * @param {google.maps.Map=} opt_map Optional map to open on.
	 * @param {google.maps.MVCObject=} opt_anchor Optional anchor to position at.
	 */
	InfoBubble.prototype.open = function (opt_map, opt_anchor) {
	  var that = this;
	  window.setTimeout(function () {
	    that.open_(opt_map, opt_anchor);
	  }, 0);
	};
	
	/**
	 * Open the InfoBubble
	 * @private
	 * @param {google.maps.Map=} opt_map Optional map to open on.
	 * @param {google.maps.MVCObject=} opt_anchor Optional anchor to position at.
	 */
	InfoBubble.prototype.open_ = function (opt_map, opt_anchor) {
	  this.updateContent_();
	
	  if (opt_map) {
	    this.setMap(opt_map);
	  }
	
	  if (opt_anchor) {
	    this.set('anchor', opt_anchor);
	    this.bindTo('anchorPoint', opt_anchor);
	    this.bindTo('position', opt_anchor);
	  }
	
	  // Show the bubble and the show
	  this.bubble_.style['display'] = this.bubbleShadow_.style['display'] = '';
	  var animation = !this.get('disableAnimation');
	
	  if (animation) {
	    // Add the animation
	    this.bubble_.className += ' ' + this.animationName_;
	    this.bubbleShadow_.className += ' ' + this.animationName_;
	  }
	
	  this.redraw_();
	  this.isOpen_ = true;
	
	  var pan = !this.get('disableAutoPan');
	  if (pan) {
	    var that = this;
	    window.setTimeout(function () {
	      // Pan into view, done in a time out to make it feel nicer :)
	      that.panToView();
	    }, 200);
	  }
	};
	InfoBubble.prototype['open'] = InfoBubble.prototype.open;
	
	/**
	 * Set the position of the InfoBubble
	 *
	 * @param {google.maps.LatLng} position The position to set.
	 */
	InfoBubble.prototype.setPosition = function (position) {
	  if (position) {
	    this.set('position', position);
	  }
	};
	InfoBubble.prototype['setPosition'] = InfoBubble.prototype.setPosition;
	
	/**
	 * Returns the position of the InfoBubble
	 *
	 * @return {google.maps.LatLng} the position.
	 */
	InfoBubble.prototype.getPosition = function () {
	  return (/** @type {google.maps.LatLng} */this.get('position')
	  );
	};
	InfoBubble.prototype['getPosition'] = InfoBubble.prototype.getPosition;
	
	/**
	 * position changed MVC callback
	 */
	InfoBubble.prototype.position_changed = function () {
	  this.draw();
	};
	InfoBubble.prototype['position_changed'] = InfoBubble.prototype.position_changed;
	
	/**
	 * Pan the InfoBubble into view
	 */
	InfoBubble.prototype.panToView = function () {
	  var projection = this.getProjection();
	
	  if (!projection) {
	    // The map projection is not ready yet so do nothing
	    return;
	  }
	
	  if (!this.bubble_) {
	    // No Bubble yet so do nothing
	    return;
	  }
	
	  var anchorHeight = this.getAnchorHeight_();
	  var height = this.bubble_.offsetHeight + anchorHeight;
	  var map = this.get('map');
	  var mapDiv = map.getDiv();
	  var mapHeight = mapDiv.offsetHeight;
	
	  var latLng = this.getPosition();
	  var centerPos = projection.fromLatLngToContainerPixel(map.getCenter());
	  var pos = projection.fromLatLngToContainerPixel(latLng);
	
	  // Find out how much space at the top is free
	  var spaceTop = centerPos.y - height;
	
	  // Fine out how much space at the bottom is free
	  var spaceBottom = mapHeight - centerPos.y;
	
	  var needsTop = spaceTop < 0;
	  var deltaY = 0;
	
	  if (needsTop) {
	    spaceTop *= -1;
	    deltaY = (spaceTop + spaceBottom) / 2;
	  }
	
	  pos.y -= deltaY;
	  latLng = projection.fromContainerPixelToLatLng(pos);
	
	  if (map.getCenter() != latLng) {
	    map.panTo(latLng);
	  }
	};
	InfoBubble.prototype['panToView'] = InfoBubble.prototype.panToView;
	
	/**
	 * Converts a HTML string to a document fragment.
	 *
	 * @param {string} htmlString The HTML string to convert.
	 * @return {Node} A HTML document fragment.
	 * @private
	 */
	InfoBubble.prototype.htmlToDocumentFragment_ = function (htmlString) {
	  htmlString = htmlString.replace(/^\s*([\S\s]*)\b\s*$/, '$1');
	  var tempDiv = document.createElement('DIV');
	  tempDiv.innerHTML = htmlString;
	  if (tempDiv.childNodes.length == 1) {
	    return (/** @type {!Node} */tempDiv.removeChild(tempDiv.firstChild)
	    );
	  } else {
	    var fragment = document.createDocumentFragment();
	    while (tempDiv.firstChild) {
	      fragment.appendChild(tempDiv.firstChild);
	    }
	    return fragment;
	  }
	};
	
	/**
	 * Removes all children from the node.
	 *
	 * @param {Node} node The node to remove all children from.
	 * @private
	 */
	InfoBubble.prototype.removeChildren_ = function (node) {
	  if (!node) {
	    return;
	  }
	
	  var child;
	  while (child = node.firstChild) {
	    node.removeChild(child);
	  }
	};
	
	/**
	 * Sets the content of the infobubble.
	 *
	 * @param {string|Node} content The content to set.
	 */
	InfoBubble.prototype.setContent = function (content) {
	  this.set('content', content);
	};
	InfoBubble.prototype['setContent'] = InfoBubble.prototype.setContent;
	
	/**
	 * Get the content of the infobubble.
	 *
	 * @return {string|Node} The marker content.
	 */
	InfoBubble.prototype.getContent = function () {
	  return (/** @type {Node|string} */this.get('content')
	  );
	};
	InfoBubble.prototype['getContent'] = InfoBubble.prototype.getContent;
	
	/**
	 * Sets the marker content and adds loading events to images
	 */
	InfoBubble.prototype.updateContent_ = function () {
	  if (!this.content_) {
	    // The Content area doesnt exist.
	    return;
	  }
	
	  this.removeChildren_(this.content_);
	  var content = this.getContent();
	  if (content) {
	    if (typeof content == 'string') {
	      content = this.htmlToDocumentFragment_(content);
	    }
	    this.content_.appendChild(content);
	
	    var that = this;
	    var images = this.content_.getElementsByTagName('IMG');
	    for (var i = 0, image; image = images[i]; i++) {
	      // Because we don't know the size of an image till it loads, add a
	      // listener to the image load so the marker can resize and reposition
	      // itself to be the correct height.
	      google.maps.event.addDomListener(image, 'load', function () {
	        that.imageLoaded_();
	      });
	    }
	    google.maps.event.trigger(this, 'domready');
	  }
	  this.redraw_();
	};
	
	/**
	 * Image loaded
	 * @private
	 */
	InfoBubble.prototype.imageLoaded_ = function () {
	  var pan = !this.get('disableAutoPan');
	  this.redraw_();
	  if (pan && (this.tabs_.length == 0 || this.activeTab_.index == 0)) {
	    this.panToView();
	  }
	};
	
	/**
	 * Updates the styles of the tabs
	 * @private
	 */
	InfoBubble.prototype.updateTabStyles_ = function () {
	  if (this.tabs_ && this.tabs_.length) {
	    for (var i = 0, tab; tab = this.tabs_[i]; i++) {
	      this.setTabStyle_(tab.tab);
	    }
	    this.activeTab_.style['zIndex'] = this.baseZIndex_;
	    var borderWidth = this.getBorderWidth_();
	    var padding = this.gettabPadding_() / 2;
	    this.activeTab_.style['borderBottomWidth'] = 0;
	    this.activeTab_.style['paddingBottom'] = this.px(padding + borderWidth);
	  }
	};
	
	/**
	 * Sets the style of a tab
	 * @private
	 * @param {Element} tab The tab to style.
	 */
	InfoBubble.prototype.setTabStyle_ = function (tab) {
	  var backgroundColor = this.get('backgroundColor');
	  var borderColor = this.get('borderColor');
	  var borderRadius = this.getBorderRadius_();
	  var borderWidth = this.getBorderWidth_();
	  var padding = this.gettabPadding_();
	
	  var marginRight = this.px(-(Math.max(padding, borderRadius) / 2));
	  console.log(marginRight);
	  var borderRadiusPx = this.px(borderRadius);
	
	  var index = this.baseZIndex_;
	  if (tab.index) {
	    index -= tab.index;
	  }
	  // The styles for the tab
	  var styles = {
	    'cssFloat': 'left',
	    'position': 'relative',
	    'cursor': 'pointer',
	    'backgroundColor': backgroundColor,
	    'border': this.px(borderWidth) + ' solid ' + borderColor,
	    'padding': this.px(padding / 2) + ' ' + this.px(padding),
	    'marginRight': marginRight,
	    'whiteSpace': 'nowrap',
	    'borderRadiusTopLeft': borderRadiusPx,
	    'MozBorderRadiusTopleft': borderRadiusPx,
	    'webkitBorderTopLeftRadius': borderRadiusPx,
	    'borderRadiusTopRight': borderRadiusPx,
	    'MozBorderRadiusTopright': borderRadiusPx,
	    'webkitBorderTopRightRadius': borderRadiusPx,
	    'zIndex': index,
	    'display': 'inline'
	  };
	
	  for (var style in styles) {
	    tab.style[style] = styles[style];
	  }
	
	  var className = this.get('tabClassName');
	
	  if (className != undefined) {
	    tab.className += ' ' + className;
	  }
	  console.log(this);
	};
	
	/**
	 * Add user actions to a tab
	 * @private
	 * @param {Object} tab The tab to add the actions to.
	 */
	InfoBubble.prototype.addTabActions_ = function (tab) {
	  var that = this;
	  tab.listener_ = google.maps.event.addDomListener(tab, 'click', function () {
	    that.setTabActive_(this);
	  });
	};
	
	/**
	 * Set a tab at a index to be active
	 *
	 * @param {number} index The index of the tab.
	 */
	InfoBubble.prototype.setTabActive = function (index) {
	  var tab = this.tabs_[index - 1];
	
	  if (tab) {
	    this.setTabActive_(tab.tab);
	  }
	};
	InfoBubble.prototype['setTabActive'] = InfoBubble.prototype.setTabActive;
	
	/**
	 * Set a tab to be active
	 * @private
	 * @param {Object} tab The tab to set active.
	 */
	InfoBubble.prototype.setTabActive_ = function (tab) {
	  if (!tab) {
	    this.setContent('');
	    this.updateContent_();
	    return;
	  }
	
	  var padding = this.gettabPadding_() / 2;
	  var borderWidth = this.getBorderWidth_();
	
	  if (this.activeTab_) {
	    var activeTab = this.activeTab_;
	    activeTab.className = this.tabClassName;
	    activeTab.style['zIndex'] = this.baseZIndex_ - activeTab.index;
	    activeTab.style['paddingBottom'] = this.px(padding);
	    activeTab.style['borderBottomWidth'] = this.px(borderWidth);
	  }
	  tab.className = this.activeTabClassName;
	  tab.style['zIndex'] = this.baseZIndex_;
	  tab.style['borderBottomWidth'] = 0;
	  tab.style['marginBottomWidth'] = '-10px';
	  tab.style['paddingBottom'] = this.px(padding + borderWidth);
	
	  this.setContent(this.tabs_[tab.index].content);
	  this.updateContent_();
	
	  this.activeTab_ = tab;
	
	  this.redraw_();
	};
	
	/**
	 * Set the max width of the InfoBubble
	 *
	 * @param {number} width The max width.
	 */
	InfoBubble.prototype.setMaxWidth = function (width) {
	  this.set('maxWidth', width);
	};
	InfoBubble.prototype['setMaxWidth'] = InfoBubble.prototype.setMaxWidth;
	
	/**
	 * maxWidth changed MVC callback
	 */
	InfoBubble.prototype.maxWidth_changed = function () {
	  this.redraw_();
	};
	InfoBubble.prototype['maxWidth_changed'] = InfoBubble.prototype.maxWidth_changed;
	
	/**
	 * Set the max height of the InfoBubble
	 *
	 * @param {number} height The max height.
	 */
	InfoBubble.prototype.setMaxHeight = function (height) {
	  this.set('maxHeight', height);
	};
	InfoBubble.prototype['setMaxHeight'] = InfoBubble.prototype.setMaxHeight;
	
	/**
	 * maxHeight changed MVC callback
	 */
	InfoBubble.prototype.maxHeight_changed = function () {
	  this.redraw_();
	};
	InfoBubble.prototype['maxHeight_changed'] = InfoBubble.prototype.maxHeight_changed;
	
	/**
	 * Set the min width of the InfoBubble
	 *
	 * @param {number} width The min width.
	 */
	InfoBubble.prototype.setMinWidth = function (width) {
	  this.set('minWidth', width);
	};
	InfoBubble.prototype['setMinWidth'] = InfoBubble.prototype.setMinWidth;
	
	/**
	 * minWidth changed MVC callback
	 */
	InfoBubble.prototype.minWidth_changed = function () {
	  this.redraw_();
	};
	InfoBubble.prototype['minWidth_changed'] = InfoBubble.prototype.minWidth_changed;
	
	/**
	 * Set the min height of the InfoBubble
	 *
	 * @param {number} height The min height.
	 */
	InfoBubble.prototype.setMinHeight = function (height) {
	  this.set('minHeight', height);
	};
	InfoBubble.prototype['setMinHeight'] = InfoBubble.prototype.setMinHeight;
	
	/**
	 * minHeight changed MVC callback
	 */
	InfoBubble.prototype.minHeight_changed = function () {
	  this.redraw_();
	};
	InfoBubble.prototype['minHeight_changed'] = InfoBubble.prototype.minHeight_changed;
	
	/**
	 * Add a tab
	 *
	 * @param {string} label The label of the tab.
	 * @param {string|Element} content The content of the tab.
	 */
	InfoBubble.prototype.addTab = function (label, content) {
	  var tab = document.createElement('DIV');
	  tab.innerHTML = label;
	
	  this.setTabStyle_(tab);
	  this.addTabActions_(tab);
	
	  this.tabsContainer_.appendChild(tab);
	
	  this.tabs_.push({
	    label: label,
	    content: content,
	    tab: tab
	  });
	
	  tab.index = this.tabs_.length - 1;
	  tab.style['zIndex'] = this.baseZIndex_ - tab.index;
	
	  if (!this.activeTab_) {
	    this.setTabActive_(tab);
	  }
	
	  tab.className = tab.className + ' ' + this.animationName_;
	
	  this.redraw_();
	};
	InfoBubble.prototype['addTab'] = InfoBubble.prototype.addTab;
	
	/**
	 * Update a tab at a speicifc index
	 *
	 * @param {number} index The index of the tab.
	 * @param {?string} opt_label The label to change to.
	 * @param {?string} opt_content The content to update to.
	 */
	InfoBubble.prototype.updateTab = function (index, opt_label, opt_content) {
	  if (!this.tabs_.length || index < 0 || index >= this.tabs_.length) {
	    return;
	  }
	
	  var tab = this.tabs_[index];
	  if (opt_label != undefined) {
	    tab.tab.innerHTML = tab.label = opt_label;
	  }
	
	  if (opt_content != undefined) {
	    tab.content = opt_content;
	  }
	
	  if (this.activeTab_ == tab.tab) {
	    this.setContent(tab.content);
	    this.updateContent_();
	  }
	  this.redraw_();
	};
	InfoBubble.prototype['updateTab'] = InfoBubble.prototype.updateTab;
	
	/**
	 * Remove a tab at a specific index
	 *
	 * @param {number} index The index of the tab to remove.
	 */
	InfoBubble.prototype.removeTab = function (index) {
	  if (!this.tabs_.length || index < 0 || index >= this.tabs_.length) {
	    return;
	  }
	
	  var tab = this.tabs_[index];
	  tab.tab.parentNode.removeChild(tab.tab);
	
	  google.maps.event.removeListener(tab.tab.listener_);
	
	  this.tabs_.splice(index, 1);
	
	  //delete tab;
	
	  for (var i = 0, t; t = this.tabs_[i]; i++) {
	    t.tab.index = i;
	  }
	
	  if (tab.tab == this.activeTab_) {
	    // Removing the current active tab
	    if (this.tabs_[index]) {
	      // Show the tab to the right
	      this.activeTab_ = this.tabs_[index].tab;
	    } else if (this.tabs_[index - 1]) {
	      // Show a tab to the left
	      this.activeTab_ = this.tabs_[index - 1].tab;
	    } else {
	      // No tabs left to sho
	      this.activeTab_ = undefined;
	    }
	
	    this.setTabActive_(this.activeTab_);
	  }
	
	  this.redraw_();
	};
	InfoBubble.prototype['removeTab'] = InfoBubble.prototype.removeTab;
	
	/**
	 * Get the size of an element
	 * @private
	 * @param {Node|string} element The element to size.
	 * @param {number=} opt_maxWidth Optional max width of the element.
	 * @param {number=} opt_maxHeight Optional max height of the element.
	 * @return {google.maps.Size} The size of the element.
	 */
	InfoBubble.prototype.getElementSize_ = function (element, opt_maxWidth, opt_maxHeight) {
	  var sizer = document.createElement('DIV');
	  sizer.style['display'] = 'inline';
	  sizer.style['position'] = 'absolute';
	  sizer.style['visibility'] = 'hidden';
	
	  if (typeof element == 'string') {
	    sizer.innerHTML = element;
	  } else {
	    sizer.appendChild(element.cloneNode(true));
	  }
	
	  document.body.appendChild(sizer);
	  var size = new google.maps.Size(sizer.offsetWidth, sizer.offsetHeight);
	
	  // If the width is bigger than the max width then set the width and size again
	  if (opt_maxWidth && size.width > opt_maxWidth) {
	    sizer.style['width'] = this.px(opt_maxWidth);
	    size = new google.maps.Size(sizer.offsetWidth, sizer.offsetHeight);
	  }
	
	  // If the height is bigger than the max height then set the height and size
	  // again
	  if (opt_maxHeight && size.height > opt_maxHeight) {
	    sizer.style['height'] = this.px(opt_maxHeight);
	    size = new google.maps.Size(sizer.offsetWidth, sizer.offsetHeight);
	  }
	
	  document.body.removeChild(sizer);
	  //delete sizer;
	  return size;
	};
	
	/**
	 * Redraw the InfoBubble
	 * @private
	 */
	InfoBubble.prototype.redraw_ = function () {
	  this.figureOutSize_();
	  this.positionCloseButton_();
	  this.draw();
	};
	
	/**
	 * Figure out the optimum size of the InfoBubble
	 * @private
	 */
	InfoBubble.prototype.figureOutSize_ = function () {
	  var map = this.get('map');
	
	  if (!map) {
	    return;
	  }
	
	  var padding = this.getPadding_();
	  var borderWidth = this.getBorderWidth_();
	  var borderRadius = this.getBorderRadius_();
	  var arrowSize = this.getArrowSize_();
	
	  var mapDiv = map.getDiv();
	  var gutter = arrowSize * 2;
	  var mapWidth = mapDiv.offsetWidth - gutter;
	  var mapHeight = mapDiv.offsetHeight - gutter - this.getAnchorHeight_();
	  var tabHeight = 0;
	  var width = /** @type {number} */this.get('minWidth') || 0;
	  var height = /** @type {number} */this.get('minHeight') || 0;
	  var maxWidth = /** @type {number} */this.get('maxWidth') || 0;
	  var maxHeight = /** @type {number} */this.get('maxHeight') || 0;
	
	  maxWidth = Math.min(mapWidth, maxWidth);
	  maxHeight = Math.min(mapHeight, maxHeight);
	
	  var tabWidth = 0;
	  if (this.tabs_.length) {
	    // If there are tabs then you need to check the size of each tab's content
	    for (var i = 0, tab; tab = this.tabs_[i]; i++) {
	      var tabSize = this.getElementSize_(tab.tab, maxWidth, maxHeight);
	      var contentSize = this.getElementSize_(tab.content, maxWidth, maxHeight);
	
	      if (width < tabSize.width) {
	        width = tabSize.width;
	      }
	
	      // Add up all the tab widths because they might end up being wider than
	      // the content
	      tabWidth += tabSize.width;
	
	      if (height < tabSize.height) {
	        height = tabSize.height;
	      }
	
	      if (tabSize.height > tabHeight) {
	        tabHeight = tabSize.height;
	      }
	
	      if (width < contentSize.width) {
	        width = contentSize.width;
	      }
	
	      if (height < contentSize.height) {
	        height = contentSize.height;
	      }
	    }
	  } else {
	    var content = /** @type {string|Node} */this.get('content');
	    if (typeof content == 'string') {
	      content = this.htmlToDocumentFragment_(content);
	    }
	    if (content) {
	      var contentSize = this.getElementSize_(content, maxWidth, maxHeight);
	
	      if (width < contentSize.width) {
	        width = contentSize.width;
	      }
	
	      if (height < contentSize.height) {
	        height = contentSize.height;
	      }
	    }
	  }
	
	  if (maxWidth) {
	    width = Math.min(width, maxWidth);
	  }
	
	  if (maxHeight) {
	    height = Math.min(height, maxHeight);
	  }
	
	  width = Math.max(width, tabWidth);
	
	  if (width == tabWidth) {
	    width = width + 2 * padding;
	  }
	
	  arrowSize = arrowSize * 2;
	  width = Math.max(width, arrowSize);
	
	  // Maybe add this as a option so they can go bigger than the map if the user
	  // wants
	  if (width > mapWidth) {
	    width = mapWidth;
	  }
	
	  if (height > mapHeight) {
	    height = mapHeight - tabHeight;
	  }
	
	  if (this.tabsContainer_) {
	    this.tabHeight_ = tabHeight;
	    this.tabsContainer_.style['width'] = this.px(tabWidth);
	  }
	
	  this.contentContainer_.style['width'] = this.px(width);
	  this.contentContainer_.style['height'] = this.px(height);
	};
	
	/**
	 *  Get the height of the anchor
	 *
	 *  This function is a hack for now and doesn't really work that good, need to
	 *  wait for pixelBounds to be correctly exposed.
	 *  @private
	 *  @return {number} The height of the anchor.
	 */
	InfoBubble.prototype.getAnchorHeight_ = function () {
	  var anchor = this.get('anchor');
	  if (anchor) {
	    var anchorPoint = /** @type google.maps.Point */this.get('anchorPoint');
	
	    if (anchorPoint) {
	      return -1 * anchorPoint.y;
	    }
	  }
	  return 0;
	};
	
	InfoBubble.prototype.anchorPoint_changed = function () {
	  this.draw();
	};
	InfoBubble.prototype['anchorPoint_changed'] = InfoBubble.prototype.anchorPoint_changed;
	
	/**
	 * Position the close button in the right spot.
	 * @private
	 */
	InfoBubble.prototype.positionCloseButton_ = function () {
	  var br = this.getBorderRadius_();
	  var bw = this.getBorderWidth_();
	
	  var right = 6;
	  var top = 6;
	
	  if (this.tabs_.length && this.tabHeight_) {
	    top += this.tabHeight_;
	  }
	
	  top += bw;
	  right += bw;
	
	  var c = this.contentContainer_;
	  if (c && c.clientHeight < c.scrollHeight) {
	    // If there are scrollbars then move the cross in so it is not over
	    // scrollbar
	    right += 15;
	  }
	
	  this.close_.style['right'] = this.px(right);
	  this.close_.style['top'] = this.px(top);
	};

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** js/page-store-map.js
 **/